var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _symbol164, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _symbol173, _symbol174, _symbol175, _symbol176, _symbol177, _symbol178, _symbol179, _symbol180, _symbol181, _symbol182, _symbol183, _symbol184, _symbol185, _symbol186, _symbol187, _symbol188, _symbol189, _symbol190, _symbol191, _symbol192, _symbol193, _symbol194, _symbol195, _symbol196, _symbol197, _symbol198, _symbol199, _symbol200, _symbol201, _symbol202, _symbol203, _symbol204, _symbol205, _symbol206, _symbol207, _symbol208, _symbol209, _symbol210, _symbol211, _symbol212;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBundle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "247connected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.325 47.767H19v-6h11.558l2.874 2.139 5.089 16.99 9.572-37.792 5.822.022 6.813 27.773 1.879-6.918 2.896-2.213H77v6h-9.203l-4.321 15.904-5.81-.071-6.712-27.358-9.284 36.653-5.782.124-7.563-25.253zm56.561 21.119c0 8.822-7.178 16-16 16H27.114c-8.822 0-16-7.178-16-16V50.529h-8v18.356c0 13.233 10.767 24 24 24h41.771c13.233 0 24-10.767 24-24V51h-8v17.886zm-16-65.772H27.114c-13.233 0-24 10.766-24 24v17.415h8V27.114c0-8.822 7.178-16 16-16h41.771c8.822 0 16 7.178 16 16V45h8V27.114c.001-13.234-10.766-24-23.999-24z",
    fill: "#0071B9"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 37 53",
    id: "Doors-sel-both",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.634 42.443V10.578a.7.7 0 01.336-.6L18.084.095a.7.7 0 01.7 0l17.133 9.86a.7.7 0 01.352.6v31.848a.7.7 0 01-.352.6l-17.159 9.903a.7.7 0 01-.7 0L.986 43.043a.7.7 0 01-.352-.6zm2.673-29.171v28.115l5.327 3.077V16.349l-5.327-3.077zm7.927 4.579v28.115l5.954 3.439V21.29l-5.954-3.44zm-6.726-6.88l12.68 7.315V3.638l-12.68 7.334zM19.88 34.82v14.437l12.514-7.227-12.514-7.21zm0-13.55V31.81l13.882 8.045V13.269l-13.881 8zm0-17.548V18.22l12.556-7.248L19.882 3.72z",
    fill: "#E3E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.307 41.386V13.271l5.327 3.077v28.067l-5.327-3.029zM11.233 45.894l5.954 3.386V21.289l-5.954-3.44v28.045z",
    fill: "#1450F5"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 37 53",
    id: "Doors-sel-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.975 42.443V10.578a.7.7 0 01.336-.6L18.425.095a.7.7 0 01.7 0l17.134 9.86a.7.7 0 01.352.6v31.848a.699.699 0 01-.352.6L19.1 52.906a.7.7 0 01-.7 0L1.327 43.043a.7.7 0 01-.352-.6zm2.673-29.171v28.115l5.327 3.077V16.349l-5.327-3.077zm7.927 4.579v28.115l5.954 3.439V21.29l-5.954-3.44zM4.85 10.97l12.68 7.315V3.638L4.85 10.972zM20.223 34.82v14.437l12.514-7.227-12.514-7.21zm0-13.55V31.81l13.881 8.045V13.269l-13.88 8zm0-17.548V18.22l12.555-7.248L20.223 3.72z",
    fill: "#E3E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.648 41.386V13.271l5.327 3.077v28.067l-5.327-3.029z",
    fill: "#1450F5"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 36 53",
    id: "Doors-sel-right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.317 42.443V10.578a.7.7 0 01.336-.6L17.767.095a.7.7 0 01.7 0l17.134 9.86a.7.7 0 01.352.6v31.848a.7.7 0 01-.352.6l-17.159 9.903a.7.7 0 01-.7 0L.67 43.043a.7.7 0 01-.352-.6zM2.99 13.272v28.115l5.327 3.077V16.349L2.99 13.272zm7.927 4.579v28.115l5.954 3.439V21.29l-5.954-3.44zm-6.726-6.88l12.68 7.315V3.638l-12.68 7.334zM19.565 34.82v14.437l12.514-7.227-12.514-7.21zm0-13.55V31.81l13.881 8.045V13.269l-13.88 8zm0-17.548V18.22l12.555-7.248L19.565 3.72z",
    fill: "#E3E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.918 45.894l5.953 3.386V21.289l-5.953-3.44v28.045z",
    fill: "#1450F5"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Spinner",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, "@keyframes spinner_AtaB{to{transform:rotate(360deg)}}.spinner_ajPY{transform-o}.aespinner_ajPY{transform-origin:center;animation:spinner_AtaB 1s infinite linear}"), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aeclip0_10028_86254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 20,
    height: 20,
    rx: 10,
    transform: "rotate(-90 2 22)",
    stroke: "#F3F6FE",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.652 16.995c.961.555 2.208.229 2.595-.812A11.996 11.996 0 0021.52 4.695 12 12 0 002.753 4.35c-.707.856-.366 2.099.595 2.654.962.555 2.176.201 2.954-.591a7.979 7.979 0 0113.385 7.728c-.298 1.07.003 2.298.965 2.853z",
    fill: "#1450F5",
    className: "aespinner_ajPY"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aeclip0_10028_86254"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 110.22 210.218",
    id: "deep",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.249L100.105 0a10.659 10.659 0 017.095 2.789A11.821 11.821 0 01110.105 10l.1 189.969a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039l-90.038.249a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-181.924h10l.124 181.675h90.018L100.109 10 .067 10.249s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 47 67",
    id: "deep_au_14_20_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("image", {
    width: 47,
    height: 67,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABDCAYAAAAMEVyNAAADjUlEQVRogWJkYGBgOHbqTD8DA0MBiD1EwAQGBoZGAAAAAP//Yh6CDgcBCwYGBg4AAAAA//9iPHbqzP9B4BjSAQPDBwAAAAD//2IBBf8QcrA9AwODA5jFwCAAAAAA//8Cp/mhAo6dOtPAwMBQD3YvAwMDAAAA//9iGkqORwEMDAwAAAAA//9iQUvzjVZmJiDfDX7AwMAAAAAA//8auiHPwMAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8auo5nYGAAAAAA//8CrSVGBvbQJa+DFYDWEkMAAwMDAAAA//9CdzxokTFsofHgBgwMDAAAAAD//wIlmwVDxbEogIFhAQAAAP//Ajm+ELoTYCiBCQwMDIUAAAAA//8DANzHHWYi/EgRAAAAAElFTkSuQmCC"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 140.234 200.367",
    id: "deep_au_14_20_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h120.052a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l.1 180.3a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.166a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-172.258h10l.124 172.009 120.033.249-.1-180.3H.071s-.757-2.873 2.786-6.83 7.21-3.17 7.21-3.17z",
    fill: "#338dc7"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 110.22 210.218",
    id: "deep_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.249L100.105 0a10.659 10.659 0 017.095 2.789A11.821 11.821 0 01110.105 10l.1 189.969a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039l-90.038.249a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-181.924h10l.124 181.675h90.018L100.109 10 .067 10.249s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19.85 19.837",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aja{fill:#0071b9}")), /*#__PURE__*/React.createElement("path", {
    className: "aja",
    d: "M19.122 5.159l.294-.294a1.5 1.5 0 000-2.116L17.09.427a1.532 1.532 0 00-2.12 0l-.292.292zM16.954 4.622L6.236 15.339l-1.734-1.74L15.215 2.884l-1.352-1.352-11.7 11.7a3.122 3.122 0 00-.761 1.235L.048 18.582a.955.955 0 001.206 1.207l4.114-1.353a3.154 3.154 0 001.234-.759l11.7-11.7zm-12.183 12l-2.316.762.763-2.318a.276.276 0 01.013-.028l1.571 1.567c-.011.004-.021.011-.031.014z"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 153.752 225.918",
    id: "ena_17_25_24_4500hmc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "1700 x 2500",
    d: "M11.041.07l131.733.163s4.7-.088 7.781 3.059 3.186 7.908 3.186 7.908v203.75a10.371 10.371 0 01-3.03 7.634 12.3 12.3 0 01-7.937 3.333l-131.733-.163a11.861 11.861 0 01-8.025-3.361 9.422 9.422 0 01-2.942-7.606V19.864h10.967l.022 194.655 131.711.435V11.2l-142.7-.163s-.83-3.151 3.056-7.491S11.041.07 11.041.07z",
    fill: "#c6cacc"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 153.752 225.918",
    id: "ena_17_25_24_4500hmc_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "1700 x 2500 - blue",
    d: "M11.041.07l131.733.163s4.7-.088 7.781 3.059 3.186 7.908 3.186 7.908v203.75a10.371 10.371 0 01-3.03 7.634 12.3 12.3 0 01-7.937 3.333l-131.733-.163a11.861 11.861 0 01-8.025-3.361 9.422 9.422 0 01-2.942-7.606V19.864h10.967l.022 194.655 131.711.435V11.2l-142.7-.163s-.83-3.151 3.056-7.491S11.041.07 11.041.07z",
    fill: "#0071b9"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 42 55",
    id: "glass-frameless",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.66 1.01v28.9l16.007 9.636v-28.89L24.659 1.01z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.667 44.355L16.674 54l23.992-14.455L24.66 29.91.667 44.355z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.667 15.465v28.89L16.674 54V25.101L.667 15.465z",
    fill: "#ECF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.666 10.656L16.674 25.101M40.666 10.656L16.674 25.101v28.9l23.992-14.455v-28.89zM.667 15.445l16.007 9.646 23.992-14.454L24.66 1 .667 15.445z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.667 44.355l16.007-9.627",
    stroke: "#929497",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67 20.283v28.9M.667 15.465v28.89L16.674 54V25.101L.667 15.465z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 42 55",
    id: "glass-full",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.993 1.01L1 15.465v28.89L24.993 29.91V1.01zM24.993 1.01v28.9L41 39.546v-28.89L24.993 1.01z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 44.355L17.007 54 41 39.546 24.993 29.91 1 44.355z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.313 47.432V23.601l5.385 3.25v23.822l-5.385-3.241zM2.31 42.604V18.783l5.384 3.25v23.822l-5.385-3.25z",
    fill: "#ECF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 44.355l16.007-9.627",
    stroke: "#929497",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.004 20.283v28.9L17.007 54V25.1l-8.003-4.818zm6.694 30.39l-5.394-3.25V23.6l5.394 3.25v23.822zM1 15.465v28.9l8.004 4.817v-28.9L1 15.466zm6.694 30.39L2.3 42.605V18.782l5.394 3.25v23.822z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 10.656L17.007 25.101M41 10.656L17.007 25.101v28.9L41 39.546v-28.89zM1 15.445l16.007 9.646L41 10.637 24.993 1 1 15.445zM9.004 20.283v28.9",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15.465v28.89L17.007 54V25.101L1 15.465z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 42 55",
    id: "glass-half",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.326 1.01L1.333 15.465v28.89L25.326 29.91V1.01z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 44.355L17.341 54l23.992-14.455-16.007-9.636L1.333 44.355z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.646 37.103V23.601l5.385 3.25v13.503l-5.385-3.25zM2.643 32.285V18.783l5.385 3.25v13.503l-5.385-3.251z",
    fill: "#ECF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 44.355l16.008-9.627",
    stroke: "#929497",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.337 20.283v28.9L17.34 54V25.1l-8.004-4.818zm6.694 20.07l-5.394-3.25V23.601l5.394 3.25v13.503z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 15.465v28.9l8.004 4.817v-28.9l-8.004-4.817zm6.695 20.07l-5.395-3.25V18.783l5.395 3.25v13.502z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.333 10.656L17.341 25.101M41.333 10.656L17.341 25.101v28.9l23.992-14.455v-28.89zM1.333 15.445l16.008 9.646 23.992-14.454L25.326 1 1.333 15.445zM9.337 20.283v28.9",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 15.465v28.89L17.341 54V25.101L1.333 15.465z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 90.088 120.065",
    id: "homelift_9_12_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h70.011a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.904 7.211v100a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.066A10.815 10.815 0 012.749 117a8.591 8.591 0 01-2.682-6.936V18.109h10l.02 91.706 69.99.249v-100H.067s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 90.088 120.065",
    id: "homelift_9_12_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h70.011a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.904 7.211v100a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.066A10.815 10.815 0 012.749 117a8.591 8.591 0 01-2.682-6.936V18.109h10l.02 91.706 69.99.249v-100H.067s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-1-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3475",
    transform: "translate(-.222)",
    fill: "#e0e4e6",
    d: "M0 0h46.023v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3474",
    d: "M0 0h46.023v51.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ara"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ara)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8294",
    transform: "translate(.222)",
    clipPath: "url(#arb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(-.222 .636)",
    clipPath: "url(#arc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    transform: "translate(1.244 1.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.536,
    height: 49.688,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 42.374,
    height: 48.526,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 41.259l7.463 8.621"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.722 40.973L2.468 49.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 11.701l8.105-9.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.939 11.844L1.866 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8293"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4509",
    d: "M36.022 41.974h-25.77V11.371h25.77z",
    fill: "#e0e4e6",
    stroke: "#babdbf"
  }))))))))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-2-panels",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "asb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3475",
    transform: "translate(-.222)",
    fill: "#e0e4e6",
    d: "M0 0h46.023v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "asc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3474",
    d: "M0 0h46.023v51.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "asa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#asa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8294",
    transform: "translate(.222)",
    clipPath: "url(#asb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(-.222 .636)",
    clipPath: "url(#asc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    transform: "translate(1.244 1.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.536,
    height: 49.688,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 42.374,
    height: 48.526,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 41.259l7.463 8.621"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.722 40.973L2.468 49.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 11.701l8.105-9.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.939 11.844L1.866 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8293"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4509",
    d: "M36.022 41.974h-25.77V11.371h25.77z",
    fill: "#e0e4e6",
    stroke: "#babdbf"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 729",
    fill: "none",
    stroke: "#babdbf",
    d: "M23.421 10.882v31.091"
  })))))))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-3-panels",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "atb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3477",
    transform: "translate(-.222)",
    fill: "#e0e4e6",
    d: "M0 0h46.023v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "atc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3476",
    d: "M0 0h46.023v51.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ata"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ata)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8296",
    transform: "translate(.222)",
    clipPath: "url(#atb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(-.222 .636)",
    clipPath: "url(#atc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    transform: "translate(1.244 1.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.536,
    height: 49.688,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 42.374,
    height: 48.526,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 41.259l7.463 8.621"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.722 40.973L2.468 49.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 11.701l8.105-9.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.939 11.844L1.866 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8295"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4510",
    d: "M36.022 41.974h-25.77V11.371h25.77z",
    fill: "#e0e4e6",
    stroke: "#babdbf"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4511",
    d: "M18.421 10.882v31.091",
    fill: "none",
    stroke: "#babdbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 730",
    fill: "none",
    stroke: "#babdbf",
    d: "M27.42 10.882v31.091"
  })))))))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-accessories",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon-accessories"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 19",
    clipPath: "url(#aua)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6069"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2945",
    d: "M18.493 15.504v.047l-.891-.518h.031a.579.579 0 01.86.469z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2946",
    d: "M28.516 10.939v1.016l-4.019 2.33v-2.283l3.268-1.876.438.25a.657.657 0 01.313.563z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2947",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.453zm-2.033 22.079V10.017l-3.346 1.939v-1.017a.657.657 0 00-.328-.563l-.422-.25 3.205-1.845L21.4 2.746v11.055l3.1-1.8v2.283l-3.1 1.783v7.975zm-10.476 7.224l9.632-5.567-9.618-5.441zm-2.033-.109v-10.9L9.924 31.72zm0-13.166v-7.956l-.876-.5v-.047a.579.579 0 00-.86-.5H17.6l-8.71-4.988v20.057zm0-10.258V2.808L9.877 8.281z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2948",
    d: "M28.516 11.955v10.852a.657.657 0 01-.969.563l-2.721-1.548a.657.657 0 01-.329-.567v-6.97z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2949",
    d: "M27.765 10.126l-3.268 1.876V9.391a.657.657 0 01.969-.563z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2950",
    d: "M18.493 15.551v2.173a.579.579 0 01-.281.5l-7.146 4.175a.579.579 0 01-.86-.5v-2.22a.579.579 0 01.281-.5l7.119-4.144z",
    fill: "#0172b9"
  })))))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 28 28",
    id: "icon-accessories-del",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#0071B9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.672 9.798V8.465h10.656v1.331c0 .002-10.656.002-10.656.002zM8.67 8.464c-.357 0-.691.14-.943.392s-.39.587-.39.943l1.334-.003-.001-1.332zm11.601.392a1.322 1.322 0 00-.943-.392l-.001 1.332 1.333.003c.001-.356-.137-.691-.389-.943zM13.329 7.47h1.341V6.136H13.33v1.27-1.27c-.357 0-.692.138-.944.391-.252.252-.39.587-.39.943 0 0 1.334-.002 1.334 0zm2.286-.943a1.323 1.323 0 00-.944-.391v1.332l1.333.002c0-.356-.137-.691-.39-.943zm1.402 13.79h-6.152l-1.33-9.51-1.38-.003 1.402 10.032c.07.483.49.847.978.847h6.812a.995.995 0 00.978-.85l1.402-10.03-1.38.004-1.33 9.51z",
    fill: "#0071B9"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "3 2 28 28",
    fill: "none",
    id: "icon-accessories-edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.268 9.268 2 17 2s14 6.268 14 14-6.268 14-14 14S3 23.732 3 16z",
    fill: "#0071B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19.64v2.027a.33.33 0 00.333.333h2.027a.312.312 0 00.233-.1l7.28-7.273-2.5-2.5L11.1 19.4a.327.327 0 00-.1.24zm11.807-6.947c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z",
    fill: "#fff"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-accessories-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "axa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 19",
    clipPath: "url(#axa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6069"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2945",
    d: "M18.493 15.504v.047l-.891-.518h.031a.579.579 0 01.86.469z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2946",
    d: "M28.516 10.939v1.016l-4.019 2.33v-2.283l3.268-1.876.438.25a.657.657 0 01.313.563z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2947",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.453zm-2.033 22.079V10.017l-3.346 1.939v-1.017a.657.657 0 00-.328-.563l-.422-.25 3.205-1.845L21.4 2.746v11.055l3.1-1.8v2.283l-3.1 1.783v7.975zm-10.476 7.224l9.632-5.567-9.618-5.441zm-2.033-.109v-10.9L9.924 31.72zm0-13.166v-7.956l-.876-.5v-.047a.579.579 0 00-.86-.5H17.6l-8.71-4.988v20.057zm0-10.258V2.808L9.877 8.281z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2948",
    d: "M28.516 11.955v10.852a.657.657 0 01-.969.563l-2.721-1.548a.657.657 0 01-.329-.567v-6.97z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2949",
    d: "M27.765 10.126l-3.268 1.876V9.391a.657.657 0 01.969-.563z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2950",
    d: "M18.493 15.551v2.173a.579.579 0 01-.281.5l-7.146 4.175a.579.579 0 01-.86-.5v-2.22a.579.579 0 01.281-.5l7.119-4.144z",
    fill: "#98caec"
  }))))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23 21",
    id: "icon-alert",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23v21H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7841",
    clipPath: "url(#aya)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4112",
    d: "M22.192 14.884L14.853 2.179A4 4 0 0011.419 0a3.994 3.994 0 00-3.432 2.18L.65 14.883a4 4 0 00-.175 4.066 4 4 0 003.608 1.881h14.671a4 4 0 003.61-1.88 4.007 4.007 0 00-.172-4.066zM20.6 17.929a2.032 2.032 0 01-1.845.863H4.083a2.025 2.025 0 01-1.842-.861 2.028 2.028 0 01.175-2.03L9.752 3.2a2.024 2.024 0 011.667-1.162 2.029 2.029 0 011.67 1.162l7.337 12.7a2.033 2.033 0 01.174 2.03z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4113",
    d: "M11.062 12.932h.761a.413.413 0 00.435-.445l.117-5.992a.425.425 0 00-.449-.449h-.98a.4.4 0 00-.435.454l.117 5.983a.395.395 0 00.434.449z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4114",
    d: "M12.028 14.098h-1.231a.362.362 0 00-.39.4v1.068a.362.362 0 00.39.4h1.231a.371.371 0 00.4-.4v-1.063a.371.371 0 00-.4-.4z"
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 13.537",
    id: "icon-arrow-blue",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aza{fill:#0060ad}")), /*#__PURE__*/React.createElement("path", {
    className: "aza",
    d: "M8.526 13.153l.188-.167 5.007-4.461h-2.43l-3.793 3.378-1.214 1.081.188.168a1.561 1.561 0 002.052 0zM14.998 6.768a.88.88 0 00-.005-.1 1.4 1.4 0 00-.466-.94l-.807-.719L8.713.551 8.526.384a1.561 1.561 0 00-2.051 0l-.19.169 1.213 1.081L11.29 5.01l.986.878H.879a.882.882 0 00-.874.786c-.007.032-.007.063-.007.095s0 .062.005.093a.882.882 0 00.874.786h13.244a.882.882 0 00.877-.88z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-arrow-right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "baa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "right arrow",
    fill: "#fff",
    clipPath: "url(#baa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2552",
    d: "M11.368 18.536l.25-.223 6.675-5.947h-3.238l-5.056 4.5-1.618 1.441.251.224a2.082 2.082 0 002.737 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2553",
    d: "M19.998 10.024a1.173 1.173 0 00-.007-.131 1.863 1.863 0 00-.622-1.254l-1.071-.957-6.68-5.947-.25-.223a2.082 2.082 0 00-2.735 0l-.254.225 1.619 1.442 5.056 4.5 1.314 1.171H1.172A1.176 1.176 0 00.007 9.898c0 .041-.007.082-.007.124s0 .082.007.124a1.176 1.176 0 001.165 1.052h17.656a1.175 1.175 0 001.17-1.174z"
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-brightness",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bba)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4171",
    d: "M10 5.323A4.677 4.677 0 1014.677 10 4.682 4.682 0 0010 5.323zm0 7.646A2.969 2.969 0 1112.969 10 2.973 2.973 0 0110 12.969zm.854-8.977H9.143V.854A.854.854 0 019.996 0a.854.854 0 01.854.852v.391zm4 2.363l-1.211-1.212 2.219-2.219a.856.856 0 011.211 1.211l-.277.279zm5.148 3.643a.854.854 0 01-.852.855h-3.14v-1.71h3.133a.854.854 0 01.857.856zm-2.929 5.865a.854.854 0 01-1.206 1.209l-.279-.277-1.945-1.943 1.209-1.209zm-7.925.145h1.708v3.135a.854.854 0 01-.853.854.854.854 0 01-.854-.852v-.393zm-4.005-2.365l1.208 1.207-2.214 2.221a.854.854 0 01-1.209-1.206l.277-.279zm-1.151-2.789H.854a.854.854 0 010-1.708h3.14v1.708zM2.929 4.137a.854.854 0 011.206-1.21l.279.277 1.942 1.939-1.208 1.212z",
    fill: "#0071b9"
  })))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 11.703 11.725",
    id: "icon-cancel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bca{fill:#29272b}")), /*#__PURE__*/React.createElement("path", {
    className: "bca",
    d: "M10.101 11.414a1.611 1.611 0 00.35.23.849.849 0 00.361.084.868.868 0 00.352-.072.955.955 0 00.312-.216 1 1 0 00.182-.326.793.793 0 00.035-.363 1.118 1.118 0 00-.108-.35 1.264 1.264 0 00-.23-.313L7.801 6.514l-1.3 1.3zM11.376 1.641a1.272 1.272 0 00.228-.314.925.925 0 00.1-.349.818.818 0 00-.065-.363.971.971 0 00-.216-.326 1 1 0 00-.3-.216.753.753 0 00-.324-.073.845.845 0 00-.337.073 1.118 1.118 0 00-.337.241l-4.273 4.27L1.58.314a1.075 1.075 0 00-.338-.241A.833.833 0 00.905 0a.766.766 0 00-.326.073 1.03 1.03 0 00-.3.216A1.013 1.013 0 00.06.615a.844.844 0 00-.061.363.9.9 0 00.1.349 1.232 1.232 0 00.23.314l4.245 4.22-4.223 4.222a1.217 1.217 0 00-.23.314 1.066 1.066 0 00-.108.35.823.823 0 00.035.363 1.03 1.03 0 00.181.326 1.01 1.01 0 00.314.216.872.872 0 00.349.072.832.832 0 00.361-.085 1.556 1.556 0 00.351-.23l4.248-4.245.011.011 1.3-1.3-.011-.011z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-ceiling",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "vr_car_edit_ceiling",
    clipPath: "url(#bda)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5759",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.88
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2610",
    d: "M32.334 31.625V8.375L20 1.25 7.667 8.375v23.25L20 38.75z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2611",
    d: "M32.333 31.667V8.375L20 1.25v23.292z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2612",
    d: "M7.667 31.667V8.375L20 1.25v23.292z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2613",
    d: "M32.334 31.667L20 24.542 7.667 31.667 20 38.75z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614",
    d: "M32.334 8.375L20 15.542 7.667 8.375 20 1.25z",
    fill: "#0172b9"
  }))))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-ceiling-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "vr_car_edit_ceiling",
    clipPath: "url(#bea)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5759",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.88
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2610",
    d: "M32.334 31.625V8.375L20 1.25 7.667 8.375v23.25L20 38.75z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2611",
    d: "M32.333 31.667V8.375L20 1.25v23.292z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2612",
    d: "M7.667 31.667V8.375L20 1.25v23.292z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2613",
    d: "M32.334 31.667L20 24.542 7.667 31.667 20 38.75z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614",
    d: "M32.334 8.375L20 15.542 7.667 8.375 20 1.25z",
    fill: "#86C2E6"
  }))))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-center-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bfb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3481",
    transform: "translate(-.222)",
    fill: "#e0e4e6",
    d: "M0 0h46.023v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3480",
    d: "M0 0h46.023v51.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bfa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8297",
    transform: "translate(.222)",
    clipPath: "url(#bfb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(-.222 .636)",
    clipPath: "url(#bfc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    transform: "translate(1.244 1.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.536,
    height: 49.688,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 42.374,
    height: 48.526,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 41.259l7.463 8.621"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M9.931 41.259L2.468 49.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 11.701l8.105-9.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.939 11.844L1.866 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4514",
    d: "M36.48 41.177H10.061V10.974H36.48z",
    fill: "#5aaadc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4515",
    d: "M10.683 11.59v28.968h25.17V11.59h-25.17m-1.244-1.232h27.658v31.435H9.439z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7603",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M28.324 11.542h8.12v29.113h-8.12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M28.324 11.542h8.12v12l-8.12 4.65z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7604",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M10.394 11.542h8.378v29.113h-8.378z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M10.394 11.542h8.378v12l-8.378 4.65z"
  })))))))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bga"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bga)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.211 3.245l-.055-.056c-.019-.018-.042-.033-.063-.051a.76.76 0 00-1 .114l-7.075 7.943-3.545-3.923-.143.163a1.341 1.341 0 000 1.765l.143.161s2.118 2.415 2.9 3.251c.058.061.253.227.253.227a.755.755 0 00.767.1.725.725 0 00.264-.188l7.565-8.495a.757.757 0 00-.006-1.01z",
    fill: "#0071b9"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-check-green",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.211 3.245l-.055-.056c-.019-.018-.042-.033-.063-.051a.76.76 0 00-1 .114l-7.075 7.943-3.545-3.923-.143.163a1.341 1.341 0 000 1.765l.143.161s2.118 2.415 2.9 3.251c.058.061.253.227.253.227a.755.755 0 00.767.1.725.725 0 00.264-.188l7.565-8.495a.757.757 0 00-.006-1.01z",
    fill: "#00BA34"
  })))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-check-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bia)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.211 3.245l-.055-.056c-.019-.018-.042-.033-.063-.051a.76.76 0 00-1 .114l-7.075 7.943-3.545-3.923-.143.163a1.341 1.341 0 000 1.765l.143.161s2.118 2.415 2.9 3.251c.058.061.253.227.253.227a.755.755 0 00.767.1.725.725 0 00.264-.188l7.565-8.495a.757.757 0 00-.006-1.01z",
    fill: "#fff"
  })))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-checkmark-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bja)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4652",
    d: "M29.69 4.4l-.05.058-14.4 16.72a1.281 1.281 0 01-.971.445h-.007a1.282 1.282 0 01-.973-.456L8.663 15.68a2.561 2.561 0 01.309-3.611l1.65 1.96 3.657 4.337L27.748 2.723A1.283 1.283 0 0129.69 4.4zm-.632 6.325l-.419-1.444-2.051 2.13a10.7 10.7 0 01.326 3.331A12.176 12.176 0 1114.739 2.563a12.658 12.658 0 018.142 3.007l1.653-1.959A15.223 15.223 0 0014.739 0a14.739 14.739 0 1014.739 14.739 13.221 13.221 0 00-.42-4.017z"
  })))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-chevron-down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bka"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.885 8.641a.252.252 0 01-.392 0l-4.3-3.665a1.647 1.647 0 00-2.284.129s5.7 4.854 5.755 4.887a1.766 1.766 0 00.322.169 1.878 1.878 0 001.407 0 1.766 1.766 0 00.322-.169c.055-.034 5.755-4.888 5.755-4.888a1.647 1.647 0 00-2.284-.128z"
  })))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-chevron-down-lg",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bla"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8599",
    clipPath: "url(#bla)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3603",
    fill: "none",
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4647",
    d: "M23.503 11.471h-3.152l-5.568 4.984a.151.151 0 01-.2 0l-5.568-4.984H5.863l7.352 6.592a2.2 2.2 0 002.935 0z",
    fill: "#0071b9"
  })))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-chevron-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.131 47.51a.735.735 0 000 .981l24.333 27.184v15.393L33.278 55.166a10.72 10.72 0 010-14.332L65.465 4.933v15.392L41.131 47.51z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-chevron-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bna"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 7.5 7.5)",
    clipPath: "url(#bna)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.885 8.641a.252.252 0 01-.392 0l-4.3-3.665a1.647 1.647 0 00-2.284.129s5.7 4.854 5.755 4.887a1.766 1.766 0 00.322.169 1.878 1.878 0 001.407 0 1.766 1.766 0 00.322-.169c.055-.034 5.755-4.888 5.755-4.888a1.647 1.647 0 00-2.284-.128L7.885 8.641z"
  })))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-chevron-up-lg",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "boa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8598",
    clipPath: "url(#boa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3603",
    fill: "none",
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4647",
    d: "M23.503 18.529h-3.152l-5.567-4.986a.151.151 0 00-.2 0l-5.569 4.986H5.863l7.352-6.592a2.2 2.2 0 012.935 0z",
    fill: "#0071b9"
  })))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0060AD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.545 8.221a5 5 0 00-7.07 0L48.01 42.686 13.545 8.221a5 5 0 10-7.071 7.071l34.465 34.465L6.474 84.222a4.998 4.998 0 003.536 8.535c1.28 0 2.559-.488 3.536-1.465l76-76a5 5 0 00-.001-7.071zM60.982 55.659l-7.07 7.07 28.563 28.563c.976.977 2.256 1.465 3.535 1.465s2.56-.488 3.535-1.465c.977-.976 1.465-2.256 1.465-3.535s-.488-2.56-1.465-3.535L60.982 55.659z"
  })))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-close-colorless",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.545 8.221a5 5 0 00-7.07 0L48.01 42.686 13.545 8.221a5 5 0 10-7.071 7.071l34.465 34.465L6.474 84.222a4.998 4.998 0 003.536 8.535c1.28 0 2.559-.488 3.536-1.465l76-76a5 5 0 00-.001-7.071zM60.982 55.659l-7.07 7.07 28.563 28.563c.976.977 2.256 1.465 3.535 1.465s2.56-.488 3.535-1.465c.977-.976 1.465-2.256 1.465-3.535s-.488-2.56-1.465-3.535L60.982 55.659z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-close-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.545 8.221a5 5 0 00-7.07 0L48.01 42.686 13.545 8.221a5 5 0 10-7.071 7.071l34.465 34.465L6.474 84.222a4.998 4.998 0 003.536 8.535c1.28 0 2.559-.488 3.536-1.465l76-76a5 5 0 00-.001-7.071zM60.982 55.659l-7.07 7.07 28.563 28.563c.976.977 2.256 1.465 3.535 1.465s2.56-.488 3.535-1.465c.977-.976 1.465-2.256 1.465-3.535s-.488-2.56-1.465-3.535L60.982 55.659z"
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-combined-left-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bsb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3481",
    transform: "translate(-.222)",
    fill: "#e0e4e6",
    d: "M0 0h46.023v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bsc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3480",
    d: "M0 0h46.023v51.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bsa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bsa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8297",
    transform: "translate(.222)",
    clipPath: "url(#bsb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(-.222 .636)",
    clipPath: "url(#bsc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    transform: "translate(1.244 1.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.536,
    height: 49.688,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 42.374,
    height: 48.526,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 41.259l7.463 8.621"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M9.931 41.259L2.468 49.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 11.701l8.105-9.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.939 11.844L1.866 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4514",
    d: "M36.48 41.177H10.061V10.974H36.48z",
    fill: "#5aaadc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4515",
    d: "M10.683 11.59v28.968h25.17V11.59h-25.17m-1.244-1.232h27.658v31.435H9.439z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7603",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M28.324 11.542h8.12v29.113h-8.12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M28.324 11.542h8.12v12l-8.12 4.65z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7604",
    fill: "#5aaadc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M10.394 11.542h8.378v29.113h-8.378z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M10.394 11.542h8.378v12l-8.378 4.65z"
  })))))))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-combined-right-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "btb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3481",
    transform: "translate(-.222)",
    fill: "#e0e4e6",
    d: "M0 0h46.023v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "btc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3480",
    d: "M0 0h46.023v51.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bta)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8297",
    transform: "translate(.222)",
    clipPath: "url(#btb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(-.222 .636)",
    clipPath: "url(#btc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    transform: "translate(1.244 1.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.536,
    height: 49.688,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 42.374,
    height: 48.526,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 41.259l7.463 8.621"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M9.931 41.259L2.468 49.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M36.053 11.701l8.105-9.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.939 11.844L1.866 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4514",
    d: "M36.48 41.177H10.061V10.974H36.48z",
    fill: "#5aaadc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4515",
    d: "M10.683 11.59v28.968h25.17V11.59h-25.17m-1.244-1.232h27.658v31.435H9.439z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7603",
    fill: "#5aaadc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M28.324 11.542h8.12v29.113h-8.12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M28.324 11.542h8.12v12l-8.12 4.65z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7604",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M10.394 11.542h8.378v29.113h-8.378z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M10.394 11.542h8.378v12l-8.378 4.65z"
  })))))))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 29.229 22.457",
    id: "icon-contact",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    className: "bua",
    d: "M28.827 2.222A3.881 3.881 0 0025.375 0H3.854A3.881 3.881 0 00.375 2.222 3.8 3.8 0 000 3.854V18.6a3.854 3.854 0 003.854 3.854h21.52a3.854 3.854 0 003.855-3.854V3.854a3.8 3.8 0 00-.402-1.632zM15.284 9.93a1.124 1.124 0 01-1.365 0L5.3 2.784h18.629zm11.134-5.567V18.6a1.071 1.071 0 01-1.071 1.071H3.854a1.071 1.071 0 01-1.07-1.071V4.363l9.368 7.737a3.961 3.961 0 004.9 0z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-contrast",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bva)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1010 10A10.014 10.014 0 0010 0zm0 1.875a8.125 8.125 0 010 16.25z",
    fill: "#0071b9"
  })))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-copy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.79 22.806h-44c-3.86 0-7 3.14-7 7v56c0 3.859 3.14 7 7 7h44c3.859 0 7-3.141 7-7v-56c0-3.86-3.141-7-7-7zm-1 62h-42v-54h42v54zm-69-20h14.269v8H12.79c-3.86 0-7-3.141-7-7v-56c0-3.86 3.14-7 7-7h44c3.859 0 7 3.14 7 7v8.625h-8v-7.625h-42v54z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-centered-full-height-glazing",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bxb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d6ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "centered full height glazing",
    clipPath: "url(#bxa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.388v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.888v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1957",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.062 22.694h44.082v50.612H26.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.312 22.944h43.582v50.112H26.312z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 72.897l12.245 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 72.897L13.408 86.775"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 23.102L81.979 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 23.102L13.408 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1958",
    transform: "translate(26.47 23.103)",
    fill: "url(#bxb)",
    d: "M0 0h22.254v49.795H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1960",
    transform: "translate(49.859 23.103)",
    fill: "url(#bxb)",
    d: "M0 0h20.26v49.795H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1959",
    fill: "#e0e4e6",
    d: "M36.299 23.103h25.094v49.795H36.299z"
  })))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-centered-full-height-mirrors",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "byb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d6ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "centered full height mirror",
    clipPath: "url(#bya)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.388v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.888v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1957",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.062 22.694h44.082v50.612H26.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.312 22.944h43.582v50.112H26.312z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 72.897l12.245 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 72.897L13.408 86.775"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 23.102L81.979 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 23.102L13.408 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1958",
    fill: "#e0e4e6",
    d: "M26.47 23.103h22.254v49.795H26.47z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1960",
    fill: "#e0e4e6",
    d: "M49.859 23.103h20.26v49.795h-20.26z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1959",
    transform: "translate(35.299 23.103)",
    fill: "url(#byb)",
    d: "M0 0h25.094v49.795H0z"
  })))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-full-glazed-back-wall",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "full glazed back wall",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    clipPath: "url(#bza)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.394v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.894v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1957",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.062 22.694h44.086v50.612H26.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.312 22.944h43.586v50.112H26.312z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    d: "M69.738 72.898l12.246 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    d: "M26.47 72.898L13.408 86.776"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    d: "M69.738 23.102L81.984 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    d: "M26.47 23.102L13.408 8.408"
  })))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-full-mirror-back-wall",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cab",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d6ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "caa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "full mirror",
    clipPath: "url(#caa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.388v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.888v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 2774",
    transform: "translate(26.062 22.694)",
    fill: "url(#cab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.832 50.362H.25V.25h43.582v50.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5v49.612h43.082V.5H.5M0 0h44.082v50.612H0V0z",
    fill: "#e0e4e6"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 72.898l12.245 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 72.898L13.408 86.776"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 23.102L81.979 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 23.102L13.408 8.408"
  })))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-mirrored-back-corners",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cbb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d6ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "mirrored corners/Glazed back",
    clipPath: "url(#cba)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.392v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.892v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 2774",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.897 73.056H26.313V22.944h43.584v50.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.563 23.194v49.612h43.084V23.194H26.563m-.5-.5h44.084v50.612H26.063V22.694z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.738 72.898l12.246 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.47 72.898L13.408 86.776"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.738 23.102L81.984 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.47 23.102L13.408 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2775",
    d: "M0 2.447l3.7-4.283v58.064L0 51.818z",
    transform: "translate(70.065 20.86)",
    fill: "url(#cbb)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2776",
    d: "M4.007 2.554L.133-1.815.014 55.963l4-4.242z",
    transform: "translate(22.075 20.88)",
    fill: "url(#cbb)"
  })))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-mirrored-back-corners-and-glazed-back",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ccb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d6ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "mirrored corners/Glazed back",
    clipPath: "url(#cca)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.392v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.892v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 2774",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.897 73.056H26.313V22.944h43.584v50.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.563 23.194v49.612h43.084V23.194H26.563m-.5-.5h44.084v50.612H26.063V22.694z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.738 72.898l12.246 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.47 72.898L13.408 86.776"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.738 23.102L81.984 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.47 23.102L13.408 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2775",
    d: "M0 2.447l3.7-4.283v58.064L0 51.818z",
    transform: "translate(70.065 20.86)",
    fill: "url(#ccb)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2776",
    d: "M4.007 2.554L.133-1.815.014 55.963l4-4.242z",
    transform: "translate(22.075 20.88)",
    fill: "url(#ccb)"
  })))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "full glazed back wall",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    clipPath: "url(#cda)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.394v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.894v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1957",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.062 22.694h44.086v50.612H26.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.312 22.944h43.586v50.112H26.312z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    d: "M69.738 72.898l12.246 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    d: "M26.47 72.898L13.408 86.776"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    d: "M69.738 23.102L81.984 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    d: "M26.47 23.102L13.408 8.408"
  })))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-deco-mirrors-offset-mirror",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ceb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d6ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "offset mirror",
    clipPath: "url(#cea)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 8h69.388v80H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.25 8.25h68.888v79.5H13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1957",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.062 22.694h44.082v50.612H26.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.312 22.944h43.582v50.112H26.312z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 72.897l12.245 14.694"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 72.897L13.408 86.775"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M69.734 23.102L81.979 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 0.5,
    d: "M26.469 23.102L13.408 8.408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1958",
    fill: "#fff",
    d: "M26.47 23.103h22.788v49.795H26.47z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1960",
    transform: "translate(49.397 23.103)",
    fill: "url(#ceb)",
    d: "M0 0h20.746v49.795H0z"
  })))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 25",
    id: "icon-delete",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cfa{fill:#e0e4e6}.cfb{fill:#3b4245}")), /*#__PURE__*/React.createElement("path", {
    className: "cfa",
    d: "M12.5 0A12.5 12.5 0 110 12.5 12.5 12.5 0 0112.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cfb",
    d: "M16.051 8.583H7.949A.915.915 0 007 9.477v.4h9.6l.4-.027v-.4a.912.912 0 00-.949-.867zM14.537 17.588H9.464l-.987-6.914H7.033l1.029 7.18a1.325 1.325 0 001.384 1.007h5.116a1.326 1.326 0 001.385-1.008l1.015-7.183h-1.44zM11.185 7.829l-.009-.456c0-.205 0-.462.826-.462a1.225 1.225 0 01.7.143c.056.041.121.115.119.325l-.012.449h1.275l.013-.447a1.519 1.519 0 00-.62-1.293 2.5 2.5 0 00-1.485-.394c-1.881 0-2.091 1.17-2.092 1.675l.01.458h1.274z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-digital-services",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.175 86h.268v10l-.973-.021C20.444 93.828 2.172 75.556.021 52.53L0 51.558h10v.268C11.793 69.887 26.113 84.207 44.175 86zM86 51.825C84.211 69.843 69.888 84.162 51.819 86h-.262v10h.746l.238-.022c23.023-2.203 41.291-20.476 43.437-43.447l.022-.973H86v.267zm0-7.65v.268h10l-.021-.973C93.828 20.444 75.556 2.171 52.53.021L51.558 0v10h.268C69.887 11.792 84.207 26.113 86 44.175zm-76 0C11.791 26.159 26.113 11.838 44.181 10h.262V0l-.984.023C20.435 2.226 2.167 20.498.021 43.47L0 44.443h10v-.268zm53.476 19.496l4.321-15.904H77v-6H65.503l-2.896 2.213-1.879 6.918-6.813-27.773-5.822-.022-9.572 37.792-5.089-16.99-2.874-2.139H19v6h9.325l7.563 25.253 5.782-.124 9.284-36.654L57.666 63.6l5.81.071z",
    fill: "#fff"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-digital-services-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.175 86h.268v10l-.973-.021C20.444 93.828 2.172 75.556.021 52.53L0 51.558h10v.268C11.793 69.887 26.113 84.207 44.175 86zM86 51.825C84.211 69.843 69.888 84.162 51.819 86h-.262v10h.746l.238-.022c23.023-2.203 41.291-20.476 43.437-43.447l.022-.973H86v.267zm0-7.65v.268h10l-.021-.973C93.828 20.444 75.556 2.171 52.53.021L51.558 0v10h.268C69.887 11.792 84.207 26.113 86 44.175zm-76 0C11.791 26.159 26.113 11.838 44.181 10h.262V0l-.984.023C20.435 2.226 2.167 20.498.021 43.47L0 44.443h10v-.268zm53.476 19.496l4.321-15.904H77v-6H65.503l-2.896 2.213-1.879 6.918-6.813-27.773-5.822-.022-9.572 37.792-5.089-16.99-2.874-2.139H19v6h9.325l7.563 25.253 5.782-.124 9.284-36.654L57.666 63.6l5.81.071z",
    fill: "#fff"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14.563 11.738",
    id: "icon-done",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cia{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    className: "cia",
    d: "M14.333.288c-.02-.022-.042-.044-.065-.066s-.05-.039-.074-.06A.892.892 0 0013.017.3l-8.3 9.323-4.16-4.6-.168.191a1.574 1.574 0 000 2.068l.168.189s2.486 2.835 3.4 3.816c.068.071.3.267.3.267a.886.886 0 00.9.12.851.851 0 00.31-.221l8.873-9.979a.889.889 0 00-.007-1.186z"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-doors",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 27",
    clipPath: "url(#cja)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3092",
    d: "M15.006 13.55l4.347 2.5v21.125l-4.331-2.5z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3093",
    d: "M19.353 23.777v-7.721l-4.363-2.5-1.735-1.022h-.016l-4.363-2.517v21.109l4.363 2.517 1.767 1.013h.016l4.347 2.5zM33.895 7.999v24.034a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.182.072a.532.532 0 01.532 0L33.629 7.53a.532.532 0 01.266.453zm-2.033 22.079V10.017l-10.476 6.051v7.959zm-10.476 7.224l9.632-5.567-9.632-5.457zm0-23.486l9.57-5.52-9.57-5.55zm-2.033-.047V2.824L9.877 8.297z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3094",
    d: "M15.022 34.675l4.331 2.5z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3095",
    d: "M15.006 13.55v-.016l4.347 2.517z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3096",
    d: "M15.006 13.55l.016 21.125-.016-.016z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3097",
    d: "M15.006 13.55v21.109l-1.767-1.016.016-21.109 1.751 1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3098",
    d: "M13.239 12.518l.016.016-.016 21.109z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3099",
    d: "M8.876 10.016l4.363 2.5v21.127l-4.363-2.518z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3100",
    d: "M13.239 33.643v.016l-4.363-2.534z",
    fill: "#0172b9"
  })))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-doors-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cka"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 27",
    clipPath: "url(#cka)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3092",
    d: "M15.006 13.55l4.347 2.5v21.125l-4.331-2.5z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3093",
    d: "M19.353 23.777v-7.721l-4.363-2.5-1.735-1.022h-.016l-4.363-2.517v21.109l4.363 2.517 1.767 1.013h.016l4.347 2.5zM33.895 7.999v24.034a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.182.072a.532.532 0 01.532 0L33.629 7.53a.532.532 0 01.266.453zm-2.033 22.079V10.017l-10.476 6.051v7.959zm-10.476 7.224l9.632-5.567-9.632-5.457zm0-23.486l9.57-5.52-9.57-5.55zm-2.033-.047V2.824L9.877 8.297z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3094",
    d: "M15.022 34.675l4.331 2.5z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3095",
    d: "M15.006 13.55v-.016l4.347 2.517z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3096",
    d: "M15.006 13.55l.016 21.125-.016-.016z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3097",
    d: "M15.006 13.55v21.109l-1.767-1.016.016-21.109 1.751 1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3098",
    d: "M13.239 12.518l.016.016-.016 21.109z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3099",
    d: "M8.876 10.016l4.363 2.5v21.127l-4.363-2.518z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3100",
    d: "M13.239 33.643v.016l-4.363-2.534z",
    fill: "#0172b9"
  })))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 21.359",
    id: "icon-download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cla{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    className: "cla",
    d: "M9.209 16.683a1.081 1.081 0 001.872-.737V1.081a1.081 1.081 0 00-2.162 0V13.2L4.15 8.08a.83.83 0 01-.058-.066l.01-.009-1.45-1.6a2.132 2.132 0 00-.761 1.523 2.224 2.224 0 00.687 1.639zM13.936 12.299h.006l.517.477 2.948-3.2a2.24 2.24 0 00.7-1.652 2.131 2.131 0 00-.76-1.528l-1.449 1.6.009.009a1.1 1.1 0 01-.073.084l-2.956 3.2-.144.152-.015-.014-.378.389v3.204l2.109-2.236zm-.267-.252l.238.219h-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cla",
    d: "M17.838 17.035v2.162H2.162v-2.162H0v3.243a1.081 1.081 0 001.081 1.081h17.838A1.081 1.081 0 0020 20.278v-3.243z"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cma"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cma)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346 -151.867)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(346 151.867)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.1 159.117l.165-.165a.844.844 0 000-1.19l-1.306-1.305a.861.861 0 00-1.192 0l-.164.16zM359.882 158.816l-6.03 6.03-.977-.978 6.03-6.029-.76-.76-6.58 6.58a1.756 1.756 0 00-.427.693l-.761 2.313a.537.537 0 00.675.681l2.313-.761a1.773 1.773 0 00.693-.427l6.584-6.582zm-6.85 6.746l-1.3.428.429-1.3a.155.155 0 01.007-.016l.882.883z"
  })))))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-edit-field",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.268 13.199l-9.452-9.542a4.254 4.254 0 00-2.995-1.253 4.237 4.237 0 00-2.985 1.232L37.849 43.508l-4.63 15.266.718 1.429c.773 1.539 1.551 2.3 3.08 3.016l1.413.661 14.851-4.688 39.973-40.039a4.231 4.231 0 00.014-5.954zM49.003 52.153l-5.99 1.891 1.908-6.291 35.877-35.774 4.141 4.179-35.936 35.995zM84 38.002h8v29c0 4.411-3.589 8-8 8H12c-4.411 0-8-3.589-8-8v-32c0-4.411 3.589-8 8-8h25.928v7.879l.004-7.871 7.992-.012-7.996 8.008c0-.004-25.928-.004-25.928-.004v32h72v-29zm-.004 0l8.008-7.996-.012 7.992-7.996.004z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-edit-pen",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.863 25.12l5.656 5.657-57.064 57.064-21.392 6.017-1.426-.772c-1.439-.778-2.513-1.828-3.38-3.301l-.849-1.442 5.846-21.946L65.196 9.454l5.656 5.657L15.43 70.533l-3.727 13.99 13.573-3.817L80.863 25.12zm-5.809-14.827l10.03 10.208 5.707-5.606-10.03-10.208-4.903 4.817 4.904-4.823a7.934 7.934 0 00-5.642-2.392 7.93 7.93 0 00-5.675 2.301s5.617 5.695 5.609 5.703zm15.742 4.602l-5.704 5.599 5.596 5.717a7.93 7.93 0 002.4-5.633 7.932 7.932 0 00-2.292-5.683z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-edit-pen-blue",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.863 25.12l5.656 5.657-57.064 57.064-21.392 6.017-1.426-.772c-1.439-.778-2.513-1.828-3.38-3.301l-.849-1.442 5.846-21.946L65.196 9.454l5.656 5.657L15.43 70.533l-3.727 13.99 13.573-3.817L80.863 25.12zm-5.809-14.827l10.03 10.208 5.707-5.606-10.03-10.208-4.903 4.817 4.904-4.823a7.934 7.934 0 00-5.642-2.392 7.93 7.93 0 00-5.675 2.301s5.617 5.695 5.609 5.703zm15.742 4.602l-5.704 5.599 5.596 5.717a7.93 7.93 0 002.4-5.633 7.932 7.932 0 00-2.292-5.683z",
    fill: "#0071B9"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 21 33",
    id: "icon-elevator",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21v33H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cqa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4648",
    d: "M20.48 16.518v13.927a2.449 2.449 0 01-2.469 2.426H3.068a2.449 2.449 0 01-2.469-2.424V16.52a2.808 2.808 0 012.811-2.81v16.35h14.259V13.708a2.807 2.807 0 012.811 2.81zm-14.83.024h9.78v-2.811H5.654zm8.478-6.21a1.054 1.054 0 001.8.742L20.071 6.9a2.106 2.106 0 00-.012-2.981l-1.478 1.49-2.347 2.363V1.054a1.055 1.055 0 00-2.109 0v.063l.002 9.215zM1.036 7.54l1.472-1.508 2.335-2.389v6.689a1.055 1.055 0 002.109 0v-.061-9.213A1.054 1.054 0 005.144.321L1 4.56a2.107 2.107 0 00.036 2.98zm9.895-.048l1.41 1.409V6.08l-2.173-2.172-1.423-1.425v2.82l2.186 2.189z",
    fill: "#0071b9"
  })))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 25",
    id: "icon-expand",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cra"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cra)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.975 21.323l-.18.01-4.812.278 1.235-1.235 3.644-.21 1.166-.067-.01.182a1.122 1.122 0 01-1.044 1.043zM4.335 21.37l6.731-6.73a.634.634 0 00.045-.844l-.048-.047-.047-.047a.634.634 0 00-.844.044L4.38 19.54l.051-.95.213-3.642.07-1.165-.185.008a1.122 1.122 0 00-1.043 1.043l-.007.182-.283 4.809-.045.775a1 1 0 00.24.72.632.632 0 00.94.05z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.514 9.975l.01-.18.278-4.812-1.234 1.234-.211 3.645-.067 1.167.18-.01a1.122 1.122 0 001.044-1.042zM21.56 3.44a.632.632 0 00-.051-.05 1 1 0 00-.715-.241l-.78.046-4.808.283-.182.007a1.122 1.122 0 00-1.043 1.043l-.01.185 1.167-.067 3.642-.216.948-.055-5.794 5.794a.634.634 0 00-.045.85l.047.046.048.048a.634.634 0 00.847-.047l6.73-6.73a.634.634 0 000-.895z"
  }))))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-floor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "csa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon-floor"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 15",
    clipPath: "url(#csa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6073"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2960",
    d: "M19.368 26.278v10.914L9.924 31.72z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2961",
    d: "M31.033 31.72l-9.632 5.566V26.278z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.454zm-2.033 22.079V10.017L21.4 16.068v7.959zm-10.476 7.224l9.632-5.567-9.618-5.441zm0-23.486l9.57-5.52L21.4 2.746zm-2.017 23.376v-10.9L9.924 31.72zm0-13.166v-7.955L8.892 10.017v20.061zm0-10.258V2.808L9.893 8.281z",
    fill: "#fff"
  })))))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-floor-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 15",
    clipPath: "url(#cta)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6073"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2960",
    d: "M19.368 26.278v10.914L9.924 31.72z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2961",
    d: "M31.033 31.72l-9.632 5.566V26.278z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.454zm-2.033 22.079V10.017L21.4 16.068v7.959zm-10.476 7.224l9.632-5.567-9.618-5.441zm0-23.486l9.57-5.52L21.4 2.746zm-2.017 23.376v-10.9L9.924 31.72zm0-13.166v-7.955L8.892 10.017v20.061zm0-10.258V2.808L9.893 8.281z",
    fill: "#fff"
  }))))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-gallery",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cuclip0_2070_33769)",
    fill: "#0071B9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.114 3.118H3.892A3.888 3.888 0 000 7.01V17.95a3.888 3.888 0 003.893 3.894h16.222a3.888 3.888 0 003.894-3.894V7.011a3.893 3.893 0 00-3.894-3.893zm1.669 14.831a1.67 1.67 0 01-1.669 1.669H3.892a1.67 1.67 0 01-1.668-1.669V7.011a1.669 1.669 0 011.668-1.668h16.222a1.669 1.669 0 011.669 1.668V17.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.751 12.649a1.08 1.08 0 00-.861-.417 1.028 1.028 0 00-.861.417l-1.278 1.554-3.222-4.695a1.113 1.113 0 00-.916-.472 1.187 1.187 0 00-.916.472L3.583 16.98a1.112 1.112 0 00.348 1.567c.172.103.368.157.568.155h14.807a1.112 1.112 0 001-.611 1.165 1.165 0 00-.14-1.195l-3.415-4.247zm-4.279 3.83H6.614l3-4.357 3.025 4.357h-.167zm2.862 0l-.25-.361.806-1 1.083 1.361h-1.64z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cuclip0_2070_33769"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 3.119)",
    d: "M0 0h24v18.722H0z"
  }))))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 36 16",
    id: "icon-hall-indicator-horizontal",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cvb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h33.663v14H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cva)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 3",
    transform: "translate(1 1)",
    clipPath: "url(#cvb)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2565",
    width: 33.663,
    height: 14,
    rx: 1,
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3896",
    d: "M1.547.57h30.416a1.027 1.027 0 011.054 1v4.491L.493 8.75V1.57a1.027 1.027 0 011.054-1z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7592",
    fill: "#f4f4f4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3881",
    d: "M24.308 4.378V2.814l2.978 3.343a1 1 0 010 1.32l-.108.123z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3882",
    d: "M23.176 11.643h.058a.572.572 0 00.509-.563V2.559a.568.568 0 00-.567-.566.417.417 0 00-.06 0 .9.9 0 00-.608.3l-3.442 3.862a1 1 0 000 1.32l.109.123 3.437-3.858v7.336a.567.567 0 00.5.563h.06"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7593",
    fill: "#f4f4f4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3881",
    d: "M11.892 9.257v1.564l2.978-3.343a1 1 0 000-1.32l-.108-.123z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3882",
    d: "M10.76 1.993h.058a.572.572 0 01.509.563v8.521a.568.568 0 01-.567.566.412.412 0 01-.06 0 .9.9 0 01-.608-.3L6.65 7.481a1 1 0 010-1.32l.109-.123 3.438 3.858V2.56a.567.567 0 01.5-.563h.06"
  })))))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 33",
    id: "icon-hall-indicator-vertical",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cwb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h14v31.388H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cwa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v33H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cwa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 1",
    transform: "translate(1 1)",
    clipPath: "url(#cwb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7589"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2561",
    width: 14,
    height: 31.388,
    rx: 1,
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3895",
    d: "M1.273 0h11.454A1.422 1.422 0 0114 1.534v12.52L0 18.4V1.534A1.422 1.422 0 011.273 0z",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7590",
    fill: "#f4f4f4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7584"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3881",
    d: "M8.2 6.546V4.985l2.972 3.336a1 1 0 010 1.317l-.108.122z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3882",
    d: "M7.071 13.796h.058a.571.571 0 00.508-.561v-8.5a.567.567 0 00-.566-.565.419.419 0 00-.06 0 .9.9 0 00-.606.3L2.97 8.324a1 1 0 000 1.317l.109.122 3.43-3.85v7.321a.566.566 0 00.5.561h.06"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7597"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3881",
    d: "M8.2 26.414v1.561l2.972-3.336a1 1 0 000-1.317l-.108-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3882",
    d: "M7.071 19.166h.058a.571.571 0 01.508.562v8.5a.567.567 0 01-.566.565.419.419 0 01-.06 0 .9.9 0 01-.606-.3L2.97 24.639a1 1 0 010-1.317l.109-.122 3.43 3.85v-7.321a.566.566 0 01.5-.562h.06"
  }))))))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-handset",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.952 76.416l-.151.203-7.246 9.107c-3.246 4.226-8.207 6.458-13.223 6.458-3.486 0-7-1.078-9.982-3.315-8.859-6.644-19.846-14.882-30.545-25.581-9.851-9.85-17.765-20.039-25.673-30.481A16.566 16.566 0 012.91 20.451 16.598 16.598 0 019.389 9.416l9.28-7.271a4.412 4.412 0 013.337-.735 4.418 4.418 0 012.792 1.732l16.393 21.422c1.792 2.584 1.16 6.155-1.41 7.959-.478.355-2.57 2.266-4.098 3.661-1.987 1.815-3.864 3.529-4.952 4.412l-5.041-6.212c.906-.735 2.868-2.526 4.598-4.107a326.82 326.82 0 013.074-2.786l-12.776-16.69-6.317 4.954c-1.915 1.448-3.115 3.49-3.434 5.795a8.61 8.61 0 001.676 6.427C20.243 38.188 27.97 48.14 37.462 57.632c10.297 10.297 21.031 18.346 29.656 24.813 3.817 2.86 9.247 2.114 12.136-1.646l5.019-6.309-16.64-12.735c-.639.761-1.493 1.762-2.626 3.086-1.705 1.99-3.637 4.247-4.503 5.354l-6.301-4.93c.976-1.246 2.882-3.474 4.726-5.628 1.394-1.627 3.302-3.856 3.644-4.332 1.798-2.562 5.368-3.196 7.954-1.405l.153.112 21.269 16.281a4.417 4.417 0 011.732 2.785 4.422 4.422 0 01-.729 3.338z"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 84",
    id: "icon-horizontal-panels",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h74v84H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7188",
    clipPath: "url(#cya)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2431",
    d: "M5.965 72.985V57.456h61.576v15.529a5 5 0 01-5 5H10.965a5 5 0 01-5-5z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2432",
    fill: "#e0e4e6",
    d: "M6.133 54.889V29.227h61.576v25.662z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2433",
    d: "M6.144 26.662V11.24a5 5 0 015-5H62.72a5 5 0 015 5v15.422H6.144z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3486",
    d: "M6.019 83.117h61.815c2.76 0 5.019-2.581 5.019-5.735V6.736c0-3.154-2.258-5.735-5.019-5.735H6.019C3.259 1.001 1 3.582 1 6.736v70.646c0 3.154 2.258 5.735 5.019 5.735zM5.751 3.566H68.1a2.7 2.7 0 012.506 2.863v71.258a2.7 2.7 0 01-2.506 2.864H5.749a2.7 2.7 0 01-2.506-2.864V6.429a2.7 2.7 0 012.508-2.863z",
    fill: "#a9b7c0"
  })))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 84",
    id: "icon-horizontal-panels-active",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h74v84H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7188",
    clipPath: "url(#cza)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2431",
    d: "M5.965 72.985V57.456h61.576v15.529a5 5 0 01-5 5H10.965a5 5 0 01-5-5z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2432",
    fill: "#98caec",
    d: "M6.133 54.889V29.227h61.576v25.662z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2433",
    d: "M6.144 26.662V11.24a5 5 0 015-5H62.72a5 5 0 015 5v15.422H6.144z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3486",
    d: "M6.019 83.117h61.815c2.76 0 5.019-2.581 5.019-5.735V6.736c0-3.154-2.258-5.735-5.019-5.735H6.019C3.259 1.001 1 3.582 1 6.736v70.646c0 3.154 2.258 5.735 5.019 5.735zM5.751 3.566H68.1a2.7 2.7 0 012.506 2.863v71.258a2.7 2.7 0 01-2.506 2.864H5.749a2.7 2.7 0 01-2.506-2.864V6.429a2.7 2.7 0 012.508-2.863z",
    fill: "#0071b9"
  })))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-import",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "daa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#daa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4398",
    d: "M20 1.777v15.578a1.778 1.778 0 01-1.777 1.777H2.645a1.778 1.778 0 01-1.777-1.777v-5.634H2.69v5.589h15.488V1.822H2.69V7.5H.868V1.777A1.778 1.778 0 012.645 0h15.578A1.778 1.778 0 0120 1.777zm-8.594 8.7l2.337-.008a.911.911 0 00.611-1.584l-3.483-3.168a1.764 1.764 0 00-1.306-.482 1.8 1.8 0 00-1.261.592l3.1 2.828-11.4.042.006 1.822s11.396-.045 11.396-.047zm-3.077 2.851a1.82 1.82 0 002.574.1l1.894-1.754-2.688.006z",
    fill: "#0071b9"
  })))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 18",
    id: "icon-info",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dba)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4117",
    d: "M18 1.639v14.722A1.641 1.641 0 0116.361 18H1.639A1.641 1.641 0 010 16.361V2.868h1.639v13.493h14.722V1.639H0A1.641 1.641 0 011.639 0h14.722A1.641 1.641 0 0118 1.639zM8.276 8.67v5.145h1.639V8.67a.82.82 0 10-1.639 0zm2.051-3.061a1.229 1.229 0 10-1.238 1.22 1.229 1.229 0 001.238-1.22z",
    fill: "#0071b9"
  })))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 25",
    id: "icon-info-medium",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dca{fill:#0071b9}")), /*#__PURE__*/React.createElement("path", {
    className: "dca",
    d: "M12.505 0a12.5 12.5 0 1012.5 12.5A12.5 12.5 0 0012.505 0zm0 22.67A10.171 10.171 0 1122.671 12.5a10.171 10.171 0 01-10.166 10.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dca",
    d: "M13.006 9.575h-1.027a.474.474 0 00-.508.543v8.111a.475.475 0 00.508.544h1.027a.5.5 0 00.526-.544v-8.138a.511.511 0 00-.524-.516zM13.254 6.352h-1.488a.444.444 0 00-.49.49v1.293a.444.444 0 00.49.49h1.487a.447.447 0 00.472-.49V6.842a.447.447 0 00-.472-.49z"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    fill: "#0071B9",
    id: "icon-info-square",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.662 11.791v71.871c0 4.411-3.589 8-8 8H11.791c-4.411 0-8-3.589-8-8V17.791h8v65.871h71.871V11.791H3.791c0-4.411 3.589-8 8-8h71.871c4.411 0 8 3.589 8 8zM44.194 46.115v25.118h8V46.115a4 4 0 00-8 0zm10.011-14.941a6 6 0 10-11.999-.087 6 6 0 0011.999.087z"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 22",
    id: "icon-invalid-password",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v22H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dea)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4115",
    d: "M11.518 7.358h.95a.412.412 0 01.435.435l-.114 5.805a.4.4 0 01-.421.431h-.737a.383.383 0 01-.421-.434l-.114-5.8a.385.385 0 01.422-.437zm1.05 7.8h-1.193a.351.351 0 00-.378.392v1.035a.351.351 0 00.378.392h1.192a.36.36 0 00.391-.392v-1.038a.36.36 0 00-.39-.389zM24 18.612a3.188 3.188 0 01-1.539 2.581l-.213.1H1.761l-.209-.1A3.1 3.1 0 010 18.593v-.273L10.261.568l.172-.129a3.033 3.033 0 013.114-.018l.189.134 10.261 17.776zm-2.166.2L12.201 2.124a1.684 1.684 0 00-.4 0l-9.64 16.695a1.72 1.72 0 00.2.362h19.271a1.922 1.922 0 00.202-.373z",
    fill: "#c71f25"
  })))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-landing",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6030",
    clipPath: "url(#dfa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.299 25.143l5.418-3.063v-.076L1.56 24.917a.174.174 0 000 .3l18.489 10.656 18.489-10.655a.174.174 0 000-.3l-5.046-2.85v.044l5.307 3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.049 37.37L.912 26.343a1.472 1.472 0 010-2.55l7.1-4.013v3.057l-4.031 2.28 16.065 9.258 16.094-9.274-3.949-2.232v-3.024l6.983 3.942a1.471 1.471 0 01.011 2.555z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.382 23.824V9.313l-8.334-4.811-8.333 4.811v14.511l8.333 4.811z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.049 29.763a1.129 1.129 0 01-.564-.151l-8.333-4.811a1.128 1.128 0 01-.564-.977V9.313a1.127 1.127 0 01.564-.976l8.333-4.811a1.129 1.129 0 011.128 0l8.333 4.811a1.127 1.127 0 01.564.976v14.511a1.128 1.128 0 01-.564.977l-8.333 4.811a1.129 1.129 0 01-.564.151zm-7.206-6.59l7.206 4.16 7.206-4.16V9.964l-7.206-4.16-7.206 4.16v13.209z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.049 15.314a1.13 1.13 0 01-.569-.154l-8.333-4.873a1.127 1.127 0 01.005-1.95l8.333-4.811a1.127 1.127 0 011.128 0l8.333 4.811a1.127 1.127 0 01.005 1.95l-8.333 4.873a1.131 1.131 0 01-.569.154zM13.96 9.32l6.089 3.56 6.089-3.56-6.089-3.516z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.921 14.187h2.255v14.449h-2.255z"
  }))))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 30",
    id: "icon-landing-call",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dgb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h14v28H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dga"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dga)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 3",
    transform: "translate(1 1)",
    clipPath: "url(#dgb)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2561",
    width: 14,
    height: 28,
    rx: 1,
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3895",
    d: "M1.273 0h11.454A1.355 1.355 0 0114 1.425V13.06L0 17.1V1.425A1.355 1.355 0 011.273 0z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7586"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3889",
    d: "M7.18 23.465a1.743 1.743 0 111.744-1.744 1.745 1.745 0 01-1.744 1.744zm0-3.249a1.506 1.506 0 101.505 1.505 1.508 1.508 0 00-1.505-1.505z",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7587"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3889",
    d: "M7.18 8.9a1.743 1.743 0 111.744-1.744A1.745 1.745 0 017.18 8.9zm0-3.249a1.506 1.506 0 101.505 1.505A1.508 1.508 0 007.18 5.651z",
    fill: "#f4f4f4"
  })))))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 280 300",
    id: "icon-landing-editor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h280v300H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dha)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h280v300H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7566"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2543",
    fill: "#5aaadc",
    d: "M62.105 64.677h157.503v235.756H62.105z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2554",
    fill: "#4c94ca",
    d: "M63.173 182.956h156.434v117.477H63.173z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2553",
    fill: "#86c2eb",
    d: "M67.07 70.053h152.537v230.38H67.07z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2555",
    fill: "#5aa9dc",
    d: "M67.07 182.956h152.537v117.477H67.07z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7563"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3880",
    d: "M50.905 300.194V48.94h179.44v251.493",
    fill: "none",
    stroke: "#e9e9e9",
    strokeMiterlimit: 10,
    strokeWidth: 20.55
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2552",
    fill: "#e9e9e9",
    d: "M41 38.468h199v25.806H41z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7570"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2546",
    fill: "#295192",
    d: "M138.982 64.677h1.91v235.75h-1.91z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7569"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7558"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2547",
    fill: "#169fdb",
    d: "M137.097 64.677h1.885V300.43h-1.885z",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7556"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2544",
    fill: "#c9e1f6",
    d: "M140.892 64.677h1.91V300.43h-1.91z",
    opacity: 0.5
  })))))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-left-and-right-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dib"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2666",
    fill: "#e0e4e6",
    d: "M0 0h45.58v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dic"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2674",
    d: "M0 0h45.58v51.739H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dia)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 51",
    clipPath: "url(#dib)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(0 .63)",
    clipPath: "url(#dic)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    transform: "translate(1.232 1.232)",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.116,
    height: 49.699,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 41.954,
    height: 48.537,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M35.706 41.269l7.391 8.623"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M9.835 41.269l-7.391 8.623"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M35.706 11.703l8.027-9.855"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.833 11.846L1.848 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4091",
    d: "M36.124 41.188H9.964V10.977h26.16z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4092",
    d: "M10.58 11.593v28.979h24.928V11.593H10.58m-1.232-1.232H36.74v31.442H9.348z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7603",
    fill: "#5aaadc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M28.051 11.544h8.042v29.119h-8.042z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M28.051 11.544h8.042v12l-8.042 4.654z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7604",
    fill: "#5aaadc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M10.294 11.544h8.3v29.119h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M10.294 11.544h8.3v12l-8.3 4.654z"
  })))))))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-left-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "djb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3479",
    fill: "#e0e4e6",
    d: "M0 0h45.58v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "djc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3478",
    d: "M0 0h45.58v51.739H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dja)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    clipPath: "url(#djb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(0 .63)",
    clipPath: "url(#djc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    transform: "translate(1.232 1.232)",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.116,
    height: 49.699,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 41.954,
    height: 48.537,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M35.706 41.269l7.391 8.623"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M9.835 41.269l-7.391 8.623"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M35.706 11.703l8.027-9.855"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.833 11.846L1.848 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4512",
    d: "M36.124 41.188H9.964V10.977h26.16z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4513",
    d: "M10.58 11.593v28.979h24.928V11.593H10.58m-1.232-1.232H36.74v31.442H9.348z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7603",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M28.051 11.544h8.042v29.119h-8.042z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M28.051 11.544h8.042v12l-8.042 4.654z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7604",
    fill: "#5aaadc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M10.294 11.544h8.3v29.119h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M10.294 11.544h8.3v12l-8.3 4.654z"
  })))))))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-light-blue",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dka"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.689 19.721l-.283.283a5.154 5.154 0 00-1.249 3.378h-2.606a7.747 7.747 0 012.285-5.515l.281-.282a5.193 5.193 0 10-7.847.044l.243.238a7.748 7.748 0 012.285 5.516H11.19a5.155 5.155 0 00-1.286-3.422l-.245-.24a7.8 7.8 0 1111.03 0zm-9.42 7.353a2.7 2.7 0 002.7 2.7h2.436a2.7 2.7 0 002.7-2.7v-1.648h-7.836zM16.097 1.54V.974a.978.978 0 00-.978-.975.978.978 0 00-.976.978v3.215h1.955zm8.609 4.376l.4-.4a.978.978 0 00-1.383-1.381l-2.276 2.273 1.382 1.383zm3.555 7.226h-3.215v1.955h3.217a.978.978 0 000-1.955zm-5.43 7.306l-1.382 1.382 1.874 1.875.4.4a.978.978 0 001.381-1.384zM5.533 22.322l-.4.4a.98.98 0 001.39 1.381l2.273-2.273-1.383-1.382zm-.341-9.181H1.975a.978.978 0 000 1.955h3.217zM7.408 7.79L8.79 6.408 6.915 4.533l-.4-.4a.978.978 0 00-1.38 1.385z",
    fill: "#abfefe"
  })))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-light-copper",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dla"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dla)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.689 19.721l-.283.283a5.154 5.154 0 00-1.249 3.378h-2.606a7.747 7.747 0 012.285-5.515l.281-.282a5.193 5.193 0 10-7.847.044l.243.238a7.748 7.748 0 012.285 5.516H11.19a5.155 5.155 0 00-1.286-3.422l-.245-.24a7.8 7.8 0 1111.03 0zm-9.42 7.353a2.7 2.7 0 002.7 2.7h2.436a2.7 2.7 0 002.7-2.7v-1.648h-7.836zM16.097 1.54V.974a.978.978 0 00-.978-.975.978.978 0 00-.976.978v3.215h1.955zm8.609 4.376l.4-.4a.978.978 0 00-1.383-1.381l-2.276 2.273 1.382 1.383zm3.555 7.226h-3.215v1.955h3.217a.978.978 0 000-1.955zm-5.43 7.306l-1.382 1.382 1.874 1.875.4.4a.978.978 0 001.381-1.384zM5.533 22.322l-.4.4a.98.98 0 001.39 1.381l2.273-2.273-1.383-1.382zm-.341-9.181H1.975a.978.978 0 000 1.955h3.217zM7.408 7.79L8.79 6.408 6.915 4.533l-.4-.4a.978.978 0 00-1.38 1.385z",
    fill: "#c69e6e"
  })))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-light-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dma"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dma)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.689 19.721l-.283.283a5.154 5.154 0 00-1.249 3.378h-2.606a7.747 7.747 0 012.285-5.515l.281-.282a5.193 5.193 0 10-7.847.044l.243.238a7.748 7.748 0 012.285 5.516H11.19a5.155 5.155 0 00-1.286-3.422l-.245-.24a7.8 7.8 0 1111.03 0zm-9.42 7.353a2.7 2.7 0 002.7 2.7h2.436a2.7 2.7 0 002.7-2.7v-1.648h-7.836zM16.097 1.54V.974a.978.978 0 00-.978-.975.978.978 0 00-.976.978v3.215h1.955zm8.609 4.376l.4-.4a.978.978 0 00-1.383-1.381l-2.276 2.273 1.382 1.383zm3.555 7.226h-3.215v1.955h3.217a.978.978 0 000-1.955zm-5.43 7.306l-1.382 1.382 1.874 1.875.4.4a.978.978 0 001.381-1.384zM5.533 22.322l-.4.4a.98.98 0 001.39 1.381l2.273-2.273-1.383-1.382zm-.341-9.181H1.975a.978.978 0 000 1.955h3.217zM7.408 7.79L8.79 6.408 6.915 4.533l-.4-.4a.978.978 0 00-1.38 1.385z",
    fill: "#fff"
  })))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-light-yellow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dna"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dna)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.689 19.721l-.283.283a5.154 5.154 0 00-1.249 3.378h-2.606a7.747 7.747 0 012.285-5.515l.281-.282a5.193 5.193 0 10-7.847.044l.243.238a7.748 7.748 0 012.285 5.516H11.19a5.155 5.155 0 00-1.286-3.422l-.245-.24a7.8 7.8 0 1111.03 0zm-9.42 7.353a2.7 2.7 0 002.7 2.7h2.436a2.7 2.7 0 002.7-2.7v-1.648h-7.836zM16.097 1.54V.974a.978.978 0 00-.978-.975.978.978 0 00-.976.978v3.215h1.955zm8.609 4.376l.4-.4a.978.978 0 00-1.383-1.381l-2.276 2.273 1.382 1.383zm3.555 7.226h-3.215v1.955h3.217a.978.978 0 000-1.955zm-5.43 7.306l-1.382 1.382 1.874 1.875.4.4a.978.978 0 001.381-1.384zM5.533 22.322l-.4.4a.98.98 0 001.39 1.381l2.273-2.273-1.383-1.382zm-.341-9.181H1.975a.978.978 0 000 1.955h3.217zM7.408 7.79L8.79 6.408 6.915 4.533l-.4-.4a.978.978 0 00-1.38 1.385z",
    fill: "#ffc627"
  })))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-like",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.724 17.979v3.5a7.222 7.222 0 01-7.213 7.212h-6.227a5.193 5.193 0 01-4.66-2.868L4.867 20.36a1.231 1.231 0 01-.132-.555v-.385h2l.33-.167.084.167h.048v.095l2.626 5.2a2.744 2.744 0 002.462 1.515h6.226a4.757 4.757 0 004.751-4.75v-3.5a4.721 4.721 0 00-1.388-3.36L12.01 4.739l-.472.474a2.166 2.166 0 000 3.053l2.73 2.732a1.231 1.231 0 01-.871 2.1H8.621a1.428 1.428 0 00-1.424 1.422v2.9H4.739v-2.9a3.89 3.89 0 013.89-3.89h1.8L9.8 10a4.632 4.632 0 01-.007-6.529l1.346-1.344a1.231 1.231 0 011.743 0l10.735 10.755a7.168 7.168 0 012.107 5.097z"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 18",
    id: "icon-list",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.032v1.935H6V1.032h10zM6 9.967h10V8.032H6v1.935zm0 7h10v-1.935H6v1.935zM0 3.62h3V.38H0v3.24zm0 7h3V7.38H0v3.24zm0 7h3v-3.24H0v3.24z",
    fill: "#0071B9"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 8 12",
    id: "icon-lock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dqa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4065",
    d: "M0 5.236v5.888a.877.877 0 00.875.877h6.25A.877.877 0 008 11.123V5.236zm7 5.76H1V6.238h6zm-5.5-6.54h-1v-1a3.5 3.5 0 017 0v1h-1v-1a2.5 2.5 0 00-5 0z",
    fill: "#babdbf"
  })))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 8 12",
    id: "icon-lock-active",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dra"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dra)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4065",
    d: "M0 5.236v5.888a.877.877 0 00.875.877h6.25A.877.877 0 008 11.123V5.236zm7 5.76H1V6.238h6zm-5.5-6.54h-1v-1a3.5 3.5 0 017 0v1h-1v-1a2.5 2.5 0 00-5 0z",
    fill: "#0071B9"
  })))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26 26",
    id: "icon-login",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dsa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26v26H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dsa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4508",
    d: "M25 4.132v18.695a2.034 2.034 0 01-1.913 2.132H8.328a2.034 2.034 0 01-1.917-2.132v-6.762h2.19v6.707h14.21V4.187H8.601V11h-2.19V4.132A2.034 2.034 0 018.328 2h14.759A2.034 2.034 0 0125 4.132zm-8.674 10.435l2.8-.009a1.093 1.093 0 00.734-1.9l-4.178-3.8a2.116 2.116 0 00-1.567-.579 2.164 2.164 0 00-1.514.71l3.714 3.395-15.32.05.016 2.183s15.315-.048 15.315-.05zm-3.694 3.42a2.184 2.184 0 003.089.121L17.994 16l-3.225.006z",
    fill: "#0071b9"
  })))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26 26",
    id: "icon-logout",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26v26H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dta)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4507",
    d: "M14.08 16.133h2.093v5.95a1.926 1.926 0 01-1.9 1.95H2.897A1.926 1.926 0 011 22.083V4.008a1.926 1.926 0 011.9-1.95h11.376a1.926 1.926 0 011.9 1.95v5.964H14.08V4.151H3.093v17.788H14.08zm3.644 1.259a2.09 2.09 0 002.956.125l2.182-2.007h-3.087zm6.938-5.079l-3.987-3.652a2.025 2.025 0 00-1.5-.558 2.071 2.071 0 00-1.451.675l3.545 3.26H10.436v2.093h13.518a1.046 1.046 0 00.708-1.817z",
    fill: "#0071b9"
  })))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 31",
    id: "icon-map-location",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v31H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dua)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4170",
    d: "M21.349 3.762a12.509 12.509 0 00-17.69 17.69c2.121 2.122 7.761 8.431 7.818 8.494a1.377 1.377 0 001.021.46h.006a1.378 1.378 0 001.019-.45c.062-.068 6.221-6.832 7.845-8.523a12.537 12.537 0 00-.019-17.671zm-1.968 15.762c-1.256 1.307-5.027 5.432-6.869 7.451-1.748-1.943-5.27-5.835-6.9-7.47a9.754 9.754 0 1113.774.019zm-3.955-9.983a4.133 4.133 0 11-5.845 0 4.133 4.133 0 015.845 0z"
  })))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 38 24",
    id: "icon-max-load",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dva)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4650",
    d: "M12.995 14.874a7.437 7.437 0 10-7.437-7.437 7.445 7.445 0 007.437 7.437zm0-11.742a4.306 4.306 0 11-4.306 4.306 4.311 4.311 0 014.306-4.307zM25.833 24H22.7a4.114 4.114 0 00-4.11-4.11H7.241A4.114 4.114 0 003.131 24H0a7.249 7.249 0 017.241-7.241h11.351A7.249 7.249 0 0125.833 24zm2.4-10.311a5.817 5.817 0 10-5.817-5.817 5.824 5.824 0 005.822 5.817zm0-8.5a2.686 2.686 0 11-2.685 2.686 2.689 2.689 0 012.69-2.694zm9.338 15.854h-3.126a2.547 2.547 0 00-2.545-2.548h-5.09v-3.131h5.09a5.682 5.682 0 015.676 5.675zm-10.762-5.676v3.13l-3.13-3.134z"
  })))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 30",
    id: "icon-max-speed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dwa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dwa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4651",
    d: "M20.656 7.673l.515 1.826-.039.07-3.986 7.1-.039.07a1.341 1.341 0 01-2.34-1.312l4.065-7.246zM6.504 3.188l-.111.085A16.042 16.042 0 00.072 14.159l-.017.129a4.891 4.891 0 00-.055.668h3.017c0-.056.014-.164.028-.268l.022-.169a13.011 13.011 0 015.129-8.827l.158-.12a2.079 2.079 0 01.266-.187L7.112 2.773a4.976 4.976 0 00-.608.415zm14.122 1.78l.158.065c.054.022.109.042.161.068l-.015-.008 2.009-3.485a5.007 5.007 0 00-.644-.3l-.1-.043a16.138 16.138 0 00-12.633.048l-.107.045a5.131 5.131 0 00-.653.313l2.013 3.483a1.859 1.859 0 01.174-.077l.169-.071a12.117 12.117 0 019.472-.039zM2.283 17.696l-.021-.155a4.534 4.534 0 01-.045-.522H.208a6.19 6.19 0 00.06.767l.017.141a15.741 15.741 0 006.813 11.21l1.129-1.664a13.73 13.73 0 01-5.944-9.777zM22.699 6.913l.148.115a11.317 11.317 0 014.384 7.535l.022.159c.012.088.028.179.034.261v-.028h4.693a6.276 6.276 0 00-.079-.9l-.017-.122a15.977 15.977 0 00-6.185-10.64l-.111-.086a6.609 6.609 0 00-.794-.551l-2.346 4.071c.051.029.152.109.251.186zm3.932 10.108a3.131 3.131 0 01-.042.358l-.027.194a10.746 10.746 0 01-4.566 7.369l3.035 4.423a16.121 16.121 0 006.844-11.059l.021-.149a7.5 7.5 0 00.1-1.138h-5.365z"
  })))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 27 32",
    id: "icon-max-travel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dxa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4649",
    d: "M5.653 20.708V8.121l-4.54 4.937A2.912 2.912 0 01.94 8.941l.011.01L6.036 3.4a1.457 1.457 0 012.53.986v16.326a1.458 1.458 0 01-2.915 0zm7.63-11.766L10.488 5.9l-.005 4.3 2.625 2.857a2.912 2.912 0 00.175-4.117zm9.757 11.992l.005 4.3 2.795-3.039a2.912 2.912 0 00-.175-4.117zm-9.533 1.252l5.086 5.553a1.457 1.457 0 002.53-.986v-3.739-12.053-.087a1.458 1.458 0 00-2.915 0v12.142l-4.542-4.936a2.885 2.885 0 00-.94 2.021 2.825 2.825 0 00.78 2.084zM0 31.408h26.3v-2.191H0zM26.3 0H0v2.191h26.3z"
  })))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.998 26.162l-7.92.015a7.929 7.929 0 012.336-5.66 7.935 7.935 0 015.66-2.348c0 .004 53.928.004 53.928.004 0 .008 7.916-.004 7.916-.004a7.929 7.929 0 01-2.336 5.66 7.94 7.94 0 01-5.66 2.348c0-.003-53.924-.003-53.924-.015zM75.002 44H21.074a7.913 7.913 0 00-5.66 2.344 7.929 7.929 0 00-2.336 5.66l7.92-.015c0 .011 53.924.011 53.924.011a7.92 7.92 0 005.66-2.344 7.929 7.929 0 002.336-5.66s-7.916.012-7.916.004zm0 25.826H21.074a7.913 7.913 0 00-5.66 2.344 7.929 7.929 0 00-2.336 5.66l7.92-.015c0 .012 53.924.012 53.924.012.027.004.052 0 .079 0a7.938 7.938 0 005.581-2.344 7.929 7.929 0 002.336-5.66c0-.001-7.916.011-7.916.003z"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 18",
    id: "icon-message",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.14 5.934V15c0 1.378-1.122 2.5-2.5 2.5H3.36A2.503 2.503 0 01.86 15V2.25c0-.494.21-.967.577-1.298a1 1 0 011.37.027L9.55 7.585a3.519 3.519 0 004.898 0L19.64 2.5H6.351L4.354.499h2.019L21.39.5c.435 0 .852.161 1.175.453a1 1 0 01.028 1.456l-6.745 6.605c-2.121 2.078-5.574 2.078-7.696 0L2.86 3.83V15a.5.5 0 00.5.5h17.28a.5.5 0 00.5-.5V5.934l1.999-2 .001 2z",
    fill: "#0071B9"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-mix",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#0071b9",
    clipPath: "url(#eaa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1926",
    d: "M18.901 9.285H7.371a2.843 2.843 0 00-5.511 0H.33a.714.714 0 100 1.428h1.53a2.843 2.843 0 005.511 0h11.53a.714.714 0 100-1.428z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1927",
    d: "M18.9 2.142h-2.244a2.843 2.843 0 00-5.511 0H.33a.715.715 0 100 1.429h10.815a2.843 2.843 0 005.511 0H18.9a.715.715 0 100-1.429z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1928",
    d: "M18.9 16.428h-3.673a2.843 2.843 0 00-5.511 0H.33a.715.715 0 100 1.429h9.387a2.843 2.843 0 005.511 0h3.673a.715.715 0 100-1.429z"
  })))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-model-and-layout",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 22",
    clipPath: "url(#eba)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6066"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5622",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2537",
    d: "M27.836 16.496a1.173 1.173 0 000-1.642l-1.8-1.815a1.189 1.189 0 00-1.658 0l-.235.219 3.473 3.473z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2538",
    d: "M17.574 24.642l-1.345-1.345 1.111-1.111-1.053-1.044-1.877 1.877a2.44 2.44 0 00-.594.954l-1.048 3.207a.735.735 0 00.469.939l.235.031.235-.031 3.207-1.048a2.456 2.456 0 00.97-.594l1.877-1.877-1.048-1.048zm-1.142 1l-1.8.594.594-1.8h.016l1.22 1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1981",
    d: "M23.575 18.65l2.356-2.356 1.052 1.052-2.356 2.356z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1982",
    d: "M21.169 16.256l2.356-2.356 1.052 1.052-2.356 2.356z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2539",
    d: "M16.902 13.038a1.189 1.189 0 00-1.642 0l-2.19 2.19a1.173 1.173 0 000 1.642l10.934 10.935a1.173 1.173 0 001.642 0l2.19-2.19a1.173 1.173 0 000-1.642zm7.931 13.484l-10.481-10.48 1.721-1.721 1.236 1.236-.657.657a.376.376 0 10.532.532l.657-.657 1.345 1.345-.657.657a.376.376 0 10.532.532l.657-.657 1.345 1.348-.657.657a.376.376 0 10.532.532l.657-.657 1.345 1.345-.657.657a.376.376 0 10.532.532l.657-.657 1.33 1.33-.657.657a.376.376 0 10.532.532l.657-.657 1.251 1.251z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2941",
    d: "M33.905 7.987a.532.532 0 00-.266-.454L20.719.072a.532.532 0 00-.532 0L7.266 7.518A.532.532 0 007 7.971v24.027a.532.532 0 00.266.454l12.952 7.477a.532.532 0 00.532 0l12.89-7.446a.532.532 0 00.266-.454zm-2.034 2.018v21.243l-11.418 6.585-2.08-1.22-9.5-5.475V8.847l11.58-6.691 11.419 6.629z",
    fill: "#fff"
  }))))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 25",
    id: "icon-moon",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.938 1.598a11.5 11.5 0 00-4.648-.551A1.605 1.605 0 007.9 2.101a1.629 1.629 0 00.383 1.725 9.2 9.2 0 01-3.907 15.31 1.653 1.653 0 00-1.174 1.342 1.605 1.605 0 00.697 1.607 11.524 11.524 0 006.4 1.917 11.5 11.5 0 003.639-22.404zm-2.995 1.749a9.176 9.176 0 01-.647 18.3 9.176 9.176 0 01-3.809-.839 11.474 11.474 0 004.456-17.461z",
    fill: "#0071b9"
  })))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    fill: "#C7D0D6",
    id: "icon-no-image",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.818 22.818l6.363 6.364-44 44-6.364-6.363 44.001-44.001zM94 48c0 25.405-20.595 46-46 46S2 73.405 2 48 22.595 2 48 2s46 20.595 46 46zm-8 0c0-20.953-17.047-38-38-38S10 27.047 10 48s17.047 38 38 38 38-17.047 38-38z"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-offset-rotate",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eea)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4396",
    d: "M2.605 8.052l-.561-2.25A1.453 1.453 0 013.103 4.04l.461 1.848a7.477 7.477 0 016.343-3.882A7.477 7.477 0 0117.768 9.5h-1.451a6.159 6.159 0 00-.991-3.335 6.028 6.028 0 00-5.357-2.7A6.035 6.035 0 004.844 6.59L3.95 8.23a.728.728 0 01-1.345-.178zm15.75 5.2l-.547-2.255a.728.728 0 00-1.343-.18l-.9 1.635a6.035 6.035 0 01-5.164 3.093A6.022 6.022 0 014.11 9.503H2.651a7.473 7.473 0 007.542 7.5h.248a7.474 7.474 0 006.391-3.851l.453 1.851a1.453 1.453 0 001.07-1.751z",
    fill: "#0071b9"
  })))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-offset-x",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "efa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efa)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(6 15)",
    fill: "#0071b9",
    fontSize: 16,
    fontFamily: "KONEInformation-Regular, KONE Information"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X"))))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-offset-y",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ega"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ega)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(6 15)",
    fill: "#0071b9",
    fontSize: 16,
    fontFamily: "KONEInformation-Regular, KONE Information"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y"))))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 28.313 35",
    id: "icon-open-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.912 29.638V35L1.329 20.965a5.184 5.184 0 010-6.931L13.912 0v5.362L4.08 16.346a1.729 1.729 0 000 2.308zm1.819-8.673L28.314 35v-5.362l-9.831-10.983a1.729 1.729 0 010-2.308l9.831-10.983V.002L15.731 14.035a5.184 5.184 0 000 6.93z",
    fill: "#0071b9"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 28.313 35",
    id: "icon-open-right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.402 5.362V0l12.583 14.035a5.184 5.184 0 010 6.931L14.402 35v-5.362l9.831-10.984a1.729 1.729 0 000-2.308zm-1.819 8.673L0 0v5.362l9.831 10.983a1.729 1.729 0 010 2.308L0 29.636V35l12.583-14.035a5.184 5.184 0 000-6.93z",
    fill: "#0071b9"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 20",
    id: "icon-password",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7511",
    clipPath: "url(#eja)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7510",
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3882",
    d: "M0 8.726v9.813A1.463 1.463 0 001.461 20H11.9a1.463 1.463 0 001.461-1.461V8.726zm11.692 9.6H1.67v-7.93h10.022z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3883",
    d: "M2.507 5.763a4.175 4.175 0 018.348 0V7.43h1.675V5.763a5.845 5.845 0 00-11.689 0V7.43h1.67z"
  }))))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-paste",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eka"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#0071b9",
    "data-name": "Group 6210",
    clipPath: "url(#eka)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2899",
    d: "M13.847 3.462H4.616a1.154 1.154 0 00-1.154 1.154v9.231a1.154 1.154 0 001.154 1.154h9.231a1.154 1.154 0 001.154-1.154V4.616a1.154 1.154 0 00-1.154-1.154z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2900",
    d: "M1.15 1.15h9.231v1.158h1.154V1.15A1.154 1.154 0 0010.385 0H1.15A1.154 1.154 0 000 1.15v9.231a1.154 1.154 0 001.15 1.157h1.158v-1.153H1.15z"
  })))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-pause",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.667 29.062h8V79a4 4 0 01-4 4h-22a4 4 0 01-4-4V17a4 4 0 014-4h22c0 .004 4.609 8 4.609 8l-4.691.004C76.585 21 58.667 21 58.667 21v54h14V29.062zM45.276 21l-4.609-7.997c0-.003-22-.003-22-.003a4 4 0 00-4 4v62a4 4 0 004 4h22a4 4 0 004-4V29.062h-8V75h-14V21h17.918c0 .004 4.691 0 4.691 0z",
    fill: "#fff"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 52 60",
    id: "icon-pdf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ema"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h52v60H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7232",
    clipPath: "url(#ema)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 1 Copy",
    d: "M1 59.04h46.652V15.3L31.633 1H1z",
    fill: "none",
    stroke: "#0071b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3 Copy",
    d: "M46.966 15.66H31.403V1.469",
    fill: "none",
    stroke: "#0071b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 5 Copy",
    d: "M25.452 39.957h-1.6v3.512h1.119a1.493 1.493 0 001.225-.4 2.679 2.679 0 00.356-1.575 1.966 1.966 0 00-.31-1.189.9.9 0 00-.79-.348",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 7 Copy",
    d: "M25.452 39.957h-1.6v3.512h1.119a1.493 1.493 0 001.225-.4 2.679 2.679 0 00.356-1.575 1.966 1.966 0 00-.31-1.189.9.9 0 00-.79-.348z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 9 Copy",
    d: "M34.872 41.34a5.828 5.828 0 00-.465-1.3c-.026-.04-.127-.083-.33-.083h-2.132v7.508h2.132c.1 0 .282-.013.337-.1a5.466 5.466 0 00.454-1.308 9.117 9.117 0 00.247-1.2 8.8 8.8 0 00.081-1.16 9.52 9.52 0 00-.082-1.2 7.426 7.426 0 00-.242-1.166",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 11 Copy",
    d: "M34.872 41.34a5.828 5.828 0 00-.465-1.3c-.026-.04-.127-.083-.33-.083h-2.132v7.508h2.132c.1 0 .282-.013.337-.1a5.466 5.466 0 00.454-1.308 9.117 9.117 0 00.247-1.2 8.8 8.8 0 00.081-1.16 9.52 9.52 0 00-.082-1.2 7.426 7.426 0 00-.242-1.157z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 13 Copy",
    d: "M51 52.864H15.629v-18.54H51v18.54zM39.057 37.597a.74.74 0 00-.488.163.667.667 0 00-.229.542v10.4a.678.678 0 00.228.542.736.736 0 00.49.163h.98a.778.778 0 00.429-.13.655.655 0 00.289-.575v-3.591h3.073a.735.735 0 00.381-.095.578.578 0 00.269-.525v-.911a.635.635 0 00-.227-.521.672.672 0 00-.423-.135h-3.075v-3.141h4.09a.671.671 0 00.428-.136.6.6 0 00.222-.484v-.91a.626.626 0 00-.222-.518.671.671 0 00-.428-.137zm-8.98 0a.747.747 0 00-.49.163.671.671 0 00-.228.542v10.4a.677.677 0 00.227.542.744.744 0 00.491.163h3.863a2.953 2.953 0 001.567-.384 2.7 2.7 0 001.014-1.239 9.393 9.393 0 00.712-2.119 10.882 10.882 0 00.208-2.173 10.763 10.763 0 00-.212-2.162 9.7 9.7 0 00-.7-2.122 2.675 2.675 0 00-1.021-1.239 3 3 0 00-1.563-.372zm-8.242 0a.654.654 0 00-.7.705v10.4a.654.654 0 00.7.705h1.014a.742.742 0 00.443-.146.662.662 0 00.258-.559v-3.24h1a4.19 4.19 0 002.991-1.038 4.091 4.091 0 001.109-3.1 5.87 5.87 0 00-.16-1.366 3.328 3.328 0 00-.551-1.2 2.769 2.769 0 00-1.065-.847 3.737 3.737 0 00-1.588-.307z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 15 Copy",
    d: "M51 52.864H15.629v-18.54H51v18.54zM39.057 37.597a.74.74 0 00-.488.163.667.667 0 00-.229.542v10.4a.678.678 0 00.228.542.736.736 0 00.49.163h.98a.778.778 0 00.429-.13.655.655 0 00.289-.575v-3.591h3.073a.735.735 0 00.381-.095.578.578 0 00.269-.525v-.911a.635.635 0 00-.227-.521.672.672 0 00-.423-.135h-3.075v-3.141h4.09a.671.671 0 00.428-.136.6.6 0 00.222-.484v-.91a.626.626 0 00-.222-.518.671.671 0 00-.428-.137zm-8.98 0a.747.747 0 00-.49.163.671.671 0 00-.228.542v10.4a.677.677 0 00.227.542.744.744 0 00.491.163h3.863a2.953 2.953 0 001.567-.384 2.7 2.7 0 001.014-1.239 9.393 9.393 0 00.712-2.119 10.882 10.882 0 00.208-2.173 10.763 10.763 0 00-.212-2.162 9.7 9.7 0 00-.7-2.122 2.675 2.675 0 00-1.021-1.239 3 3 0 00-1.563-.372zm-8.242 0a.654.654 0 00-.7.705v10.4a.654.654 0 00.7.705h1.014a.742.742 0 00.443-.146.662.662 0 00.258-.559v-3.24h1a4.19 4.19 0 002.991-1.038 4.091 4.091 0 001.109-3.1 5.87 5.87 0 00-.16-1.366 3.328 3.328 0 00-.551-1.2 2.769 2.769 0 00-1.065-.847 3.737 3.737 0 00-1.588-.307z",
    fill: "#0071b9",
    stroke: "#0071b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 17 Copy",
    d: "M10.336 14.677c-1.306-2.675-.008-4.783 2.195-3.366 3.523 2.267 5.17 9.308 3.354 15.545a10.848 10.848 0 01-5.017 6.512c-4.047 2.36-6.584-.995-.5-6.154 1.314-1.114 2.112-2.777 14.453-7.433 8.383-3.163 10.784 4.082 2.244 3.85-9.008-.241-13.619-2.586-16.729-8.954z",
    fill: "none",
    stroke: "#0071b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-play",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.958 50.86l-.535 1.113L26.03 82.801l-1.101-.015c-2.632-.037-6.164-2.108-7.41-4.347l-.505-.907V21.788l8.236 4.962v47.264l47.073-27.179-48.187-27.821a.38.38 0 00-.092.039.48.48 0 00.061-.051l-1.122-.653c.007-.012-5.719-3.43-5.719-3.43l.111-.187c1.337-2.351 4.242-3.847 7.554-3.847h.084l1.055.008L79.24 41.592l.532.878c1.389 2.288 1.211 6.259.186 8.39z",
    fill: "#fff"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eoa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eoa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4524",
    d: "M16.275 22.161a1.3 1.3 0 01-2.6 0v-5.859H7.812a1.3 1.3 0 010-2.6h5.859V7.839a1.3 1.3 0 012.6 0v5.859h5.859a1.3 1.3 0 010 2.6h-5.855zM2.636 15A12.338 12.338 0 0112.7 2.883l1.062-.2V0l-1.54.286a14.968 14.968 0 000 29.427l1.54.286v-2.68l-1.062-.2A12.338 12.338 0 012.636 15zM17.726.283l-1.54-.286v2.686l1.062.2a12.331 12.331 0 010 24.241l-1.062.2v2.68l1.54-.286a14.967 14.967 0 000-29.426z",
    fill: "#0071b9"
  })))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icon-premium",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "epa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7843",
    clipPath: "url(#epa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2589",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 14.75,
    height: 14.75,
    rx: 2.375
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7842",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2590",
    d: "M5 3.75h6v1.5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2591",
    d: "M5 10.75h6v1.5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2593",
    d: "M4.5 3.75H6v8.5H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2592",
    d: "M5 7.25h5v1.5H5z"
  }))))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 41.846 41.846",
    id: "icon-premium-ena",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.846 0H34a7.846 7.846 0 017.846 7.846V34A7.846 7.846 0 0134 41.846H7.846A7.846 7.846 0 010 34V7.846A7.846 7.846 0 017.846 0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.846 2.41A5.443 5.443 0 002.41 7.846V34a5.443 5.443 0 005.436 5.436H34A5.443 5.443 0 0039.436 34V7.846A5.443 5.443 0 0034 2.41H7.846m0-2.41H34a7.846 7.846 0 017.846 7.846V34A7.846 7.846 0 0134 41.846H7.846A7.846 7.846 0 010 34V7.846A7.846 7.846 0 017.846 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.429 8.932h8.326s2.8.081 4.036 2.051 1.158 3.765 1.212 5.754c-.118 2.149.147 3.232-1.761 5.335s-5.3 2.18-5.3 2.18h-3.875v-2.81h3.876a7.058 7.058 0 001.723-.346 2.935 2.935 0 001.613-1.149 8.642 8.642 0 00.757-3.21 8.024 8.024 0 00-.287-2.784 3.546 3.546 0 00-1.84-2.082 8.934 8.934 0 00-1.963-.127h-3.769l-.11 20.688a.48.48 0 01-.48.48h-2.158a.48.48 0 01-.48-.48V9.412a.48.48 0 01.48-.48z",
    fill: "#fff"
  })))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 41.846 41.846",
    id: "icon-premium-ena-inverse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.846 0H34a7.846 7.846 0 017.846 7.846V34A7.846 7.846 0 0134 41.846H7.846A7.846 7.846 0 010 34V7.846A7.846 7.846 0 017.846 0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.846 2.41A5.443 5.443 0 002.41 7.846V34a5.443 5.443 0 005.436 5.436H34A5.443 5.443 0 0039.436 34V7.846A5.443 5.443 0 0034 2.41H7.846m0-2.41H34a7.846 7.846 0 017.846 7.846V34A7.846 7.846 0 0134 41.846H7.846A7.846 7.846 0 010 34V7.846A7.846 7.846 0 017.846 0z",
    fill: "#8c9499"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.429 8.932h8.326s2.8.081 4.036 2.051 1.158 3.765 1.212 5.754c-.118 2.149.147 3.232-1.761 5.335s-5.3 2.18-5.3 2.18h-3.875v-2.81h3.876a7.058 7.058 0 001.723-.346 2.935 2.935 0 001.613-1.149 8.642 8.642 0 00.757-3.21 8.024 8.024 0 00-.287-2.784 3.546 3.546 0 00-1.84-2.082 8.934 8.934 0 00-1.963-.127h-3.769l-.11 20.688a.48.48 0 01-.48.48h-2.158a.48.48 0 01-.48-.48V9.412a.48.48 0 01.48-.48z",
    fill: "#8c9499"
  })))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icon-premium-inverse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "esa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7843",
    clipPath: "url(#esa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2589",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 14.75,
    height: 14.75,
    rx: 2.375
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7842"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2590",
    d: "M5 3.75h6v1.5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2591",
    d: "M5 10.75h6v1.5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2593",
    d: "M4.5 3.75H6v8.5H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2592",
    d: "M5 7.25h5v1.5H5z"
  }))))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 37.66 37.66",
    id: "icon-question",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eta{opacity:0}")), /*#__PURE__*/React.createElement("path", {
    className: "eta",
    d: "M0 0h37.66v37.66H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "etb",
    d: "M18.839.681a18.253 18.253 0 1018.253 18.254A18.274 18.274 0 0018.839.681zm0 33.464a15.211 15.211 0 1115.211-15.21 15.228 15.228 0 01-15.211 15.21zm5.812-20.321a5.625 5.625 0 01-2.03 5.119l-.038.03-2.341 1.769v3.1h-3.188l-.019-1.594v-2.03a2.107 2.107 0 01.791-1.65l.037-.029 2.776-2.1a2.442 2.442 0 00.836-2.344c-.044-.5-.1-1.187-1.79-1.336a10.376 10.376 0 00-2.925.13l-2.4.733v-3.309l1.109-.377a12.218 12.218 0 014.5-.344c3.781.333 4.556 2.795 4.682 4.232zm-7.814 12.111h3.585v3.585h-3.585z"
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 12",
    id: "icon-remove-item",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eua)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4420",
    d: "M11.792 1.191l-10.6 10.604a.7.7 0 01-.987-.986L5.014 6 .205 1.191a.7.7 0 01.987-.987l4.809 4.809L10.81.204a.7.7 0 11.986.987zM7.81 6.823l-.986.986 3.985 3.985a.7.7 0 10.986-.986z",
    fill: "#fff"
  })))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 46 53",
    id: "icon-right-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "evb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3483",
    fill: "#e0e4e6",
    d: "M0 0h45.58v53H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "evc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3482",
    d: "M0 0h45.58v51.739H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eva)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    clipPath: "url(#evb)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DECO5 - Centered full height glazing",
    transform: "translate(0 .63)",
    clipPath: "url(#evc)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1956",
    transform: "translate(1.232 1.232)",
    fill: "#fff",
    stroke: "#babdbf",
    strokeWidth: 1.162
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.116,
    height: 49.699,
    rx: 1.162,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.581,
    y: 0.581,
    width: 41.954,
    height: 48.537,
    rx: 0.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M35.706 41.269l7.391 8.623"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M9.835 41.269l-7.391 8.623"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M35.706 11.703l8.027-9.855"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#babdbf",
    strokeWidth: 1.162,
    d: "M10.833 11.846L1.848 1.848"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4516",
    d: "M36.124 41.188H9.964V10.977h26.16z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4517",
    d: "M10.58 11.593v28.979h24.928V11.593H10.58m-1.232-1.232H36.74v31.442H9.348z",
    fill: "#babdbf"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7603",
    fill: "#5aaadc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M28.051 11.544h8.042v29.119h-8.042z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M28.051 11.544h8.042v12l-8.042 4.654z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7604",
    fill: "#e0e4e6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M10.294 11.544h8.3v29.119h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3908",
    d: "M10.294 11.544h8.3v12l-8.3 4.654z"
  })))))))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-rotate",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ewa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1a6bbf",
    clipPath: "url(#ewa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.809 6.27h-.029c-4.875.164-9.256 1.726-11.718 4.178a6.01 6.01 0 00-1.914 5.728c.649 2.732 3.34 5.046 7.375 6.357a.85.85 0 00.524-1.617c-3.408-1.108-5.744-3.027-6.25-5.135a4.324 4.324 0 011.461-4.127C5.424 9.497 9.379 8.119 13.836 7.97a.85.85 0 00-.028-1.7zM21.39 7.299a.85.85 0 00-.262 1.658c3.409 1.107 5.745 3.027 6.248 5.136a4.324 4.324 0 01-1.461 4.127c-2.138 2.13-6.04 3.505-10.437 3.679a.85.85 0 00.067 1.7c4.811-.191 9.135-1.751 11.568-4.173a6.01 6.01 0 001.916-5.727c-.652-2.729-3.34-5.047-7.376-6.357a.844.844 0 00-.263-.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.414 21.843h-2.33a.875.875 0 00-.622 1.489l3.055 3.1a1.7 1.7 0 001.222.512h.007a1.705 1.705 0 001.226-.522L16.714 25.2a.032.032 0 01.021-.009l-1.57-1.6h.249v-1.748zM15.537 19.374l-.021.745-.554-.534-.035.037-.014-.013-1.383 1.514h2.355l.337-.325-.685-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.763 18.454a1.779 1.779 0 00-1.238.541l-.63.632 1.239 1.235.627-.629a.2.2 0 01.049-.036.107.107 0 01-.03.006l1.211-1.2a1.7 1.7 0 00-1.223-.551z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.773 2.787h-.008a1.7 1.7 0 00-1.225.522l1.254 1.218h-.043l1.585 1.607h-.239v1.749h2.331a.875.875 0 00.622-1.489l-3.055-3.1a1.705 1.705 0 00-1.222-.507zM15.996 8.603h-2.372l-.337.325.685.66v.765l.021-.745.554.534.032-.033.013.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.375 8.864l-.627.629a.205.205 0 01-.049.036.1.1 0 01.029-.007l-1.211 1.2a1.7 1.7 0 001.223.551 1.8 1.8 0 001.242-.54l.63-.633z"
  }))))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-save",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4523",
    d: "M22 7.766v13.02A1.216 1.216 0 0120.786 22H8.148v-1.778h9.037V14.19H6.815v7.816L3.213 22A1.215 1.215 0 012 20.786V3.214A1.216 1.216 0 013.214 2h10.462v1.778h-9.9v16.445h1.259v-6.271a1.542 1.542 0 011.54-1.54h10.848a1.542 1.542 0 011.54 1.54v6.27h1.259V8l-3.428-3.406V8.3a1.555 1.555 0 01-1.555 1.551H7.46A1.555 1.555 0 015.9 8.3V5.111h1.782v2.963h7.333V2H16.2a1.207 1.207 0 01.856.353L21.642 6.9a1.221 1.221 0 01.358.866z",
    fill: "#0071b9"
  })))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 15",
    id: "icon-select",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eya)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M7.885 8.641a.252.252 0 01-.392 0l-4.3-3.665a1.647 1.647 0 00-2.284.129s5.7 4.854 5.755 4.887a1.766 1.766 0 00.322.169 1.878 1.878 0 001.407 0 1.766 1.766 0 00.322-.169c.055-.034 5.755-4.888 5.755-4.888a1.647 1.647 0 00-2.284-.128z",
    fill: "#0071b9"
  })))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 15",
    id: "icon-select-active",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eza)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M7.494 6.232a.252.252 0 01.392 0l4.3 3.665a1.647 1.647 0 002.284-.129s-5.7-4.854-5.755-4.887a1.766 1.766 0 00-.322-.169 1.878 1.878 0 00-1.407 0 1.766 1.766 0 00-.322.169C6.609 4.915.909 9.769.909 9.769a1.647 1.647 0 002.284.128z",
    fill: "#0071b9"
  })))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 15",
    id: "icon-select-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "faa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#faa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M7.885 8.641a.252.252 0 01-.392 0l-4.3-3.665a1.647 1.647 0 00-2.284.129s5.7 4.854 5.755 4.887a1.766 1.766 0 00.322.169 1.878 1.878 0 001.407 0 1.766 1.766 0 00.322-.169c.055-.034 5.755-4.888 5.755-4.888a1.647 1.647 0 00-2.284-.128z",
    fill: "#fff"
  })))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icon-settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Settings wheel",
    clipPath: "url(#fba)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4169",
    d: "M21.141 12.8a6.6 6.6 0 01-8.511 8.51l-1.8-.684 1.953-1.966.758.286a4.06 4.06 0 005.238-5.238l-.285-.756 1.962-1.962zm-9.964 3.778a4.06 4.06 0 015.229-5.234l.757.284 1.958-1.968-1.808-.681a6.589 6.589 0 00-8.5 8.5l.681 1.808 1.967-1.954zM30 13.6v2.79a2.184 2.184 0 01-1.879 2.155l-1.452.2c-.1.294-.219.63-.351.939s-.277.634-.415.911l.885 1.168a2.184 2.184 0 01-.2 2.852l-1.973 1.973a2.185 2.185 0 01-2.853.2L20.6 25.9c-.276.138-.6.29-.911.415s-.645.254-.939.351l-.2 1.452A2.184 2.184 0 0116.395 30h-2.789a2.184 2.184 0 01-2.155-1.879l-.2-1.452c-.294-.1-.63-.219-.939-.352s-.635-.276-.911-.415l-1.168.885a2.184 2.184 0 01-2.852-.195L3.406 24.62a2.184 2.184 0 01-.2-2.852l.891-1.168c-.138-.276-.29-.6-.415-.91s-.254-.645-.352-.939l-1.452-.2A2.184 2.184 0 010 16.395V13.6a2.184 2.184 0 011.878-2.15l1.452-.2c.1-.293.219-.63.351-.939s.277-.635.415-.911l-.884-1.167a2.184 2.184 0 01.194-2.853L5.38 3.407a2.184 2.184 0 012.852-.2L9.4 4.1c.276-.138.6-.29.911-.415s.645-.254.939-.352l.2-1.452A2.185 2.185 0 0113.606 0h2.79a2.184 2.184 0 012.155 1.879l.2 1.452c.293.1.63.219.938.351s.635.277.911.415l1.168-.885a2.185 2.185 0 012.853.2l1.972 1.968a2.184 2.184 0 01.2 2.852L25.906 9.4c.138.276.29.6.415.911s.254.645.351.939l1.452.2A2.184 2.184 0 0130 13.6zm-2.5.285l-1.96-.27a1.251 1.251 0 01-1.036-.908 13.238 13.238 0 00-.489-1.426l-.014-.033a13.084 13.084 0 00-.664-1.348 1.251 1.251 0 01.09-1.374l1.2-1.577-1.575-1.572-1.577 1.2a1.252 1.252 0 01-1.374.09A13.168 13.168 0 0018.748 6l-.034-.014a12.987 12.987 0 00-1.426-.486 1.251 1.251 0 01-.908-1.036L16.106 2.5H13.89l-.27 1.961a1.252 1.252 0 01-.908 1.039 13.127 13.127 0 00-1.426.488L11.253 6a12.911 12.911 0 00-1.353.663 1.251 1.251 0 01-1.375-.09l-1.577-1.2-1.57 1.575 1.2 1.577A1.252 1.252 0 016.664 9.9a13.2 13.2 0 00-.658 1.352l-.014.034a12.949 12.949 0 00-.488 1.425 1.251 1.251 0 01-1.036.909l-1.96.27v2.221l1.961.27a1.253 1.253 0 011.036.908 13.181 13.181 0 00.488 1.426l.014.034a13.134 13.134 0 00.657 1.351 1.252 1.252 0 01-.09 1.374l-1.2 1.577 1.57 1.57 1.577-1.2a1.252 1.252 0 011.374-.09 13 13 0 001.357.669l.034.014a13.084 13.084 0 001.425.488 1.253 1.253 0 01.908 1.036l.27 1.961h2.217l.27-1.961a1.252 1.252 0 01.908-1.036 13.109 13.109 0 001.425-.488l.039-.014a12.98 12.98 0 001.352-.662 1.253 1.253 0 011.374.09l1.577 1.2 1.57-1.571-1.2-1.577a1.251 1.251 0 01-.09-1.374 13.2 13.2 0 00.663-1.353c0-.011.009-.022.014-.033a13.032 13.032 0 00.488-1.426 1.251 1.251 0 011.036-.908l1.961-.27v-2.227z",
    fill: "#0071b9"
  })))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-share-url",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.471 42.959a5.466 5.466 0 001.611-3.89c0-1.469-.572-2.85-1.611-3.889a5.507 5.507 0 00-7.778 0l-7.899 7.899a5.508 5.508 0 000 7.779L41.552 55.1c-4.484-4.483-4.484-11.779 0-16.263l7.899-7.899a11.426 11.426 0 018.132-3.369c3.071 0 5.959 1.196 8.131 3.369 2.173 2.171 3.369 5.06 3.369 8.131s-1.196 5.96-3.369 8.132l-2.854 2.854-4.242-4.243 2.853-2.853zM36.423 52.45l-4.242-4.242-3.108 3.108a11.425 11.425 0 00-3.369 8.131c0 3.072 1.196 5.96 3.369 8.132 2.172 2.172 5.06 3.368 8.131 3.368s5.959-1.196 8.131-3.368l7.899-7.899c4.483-4.483 4.483-11.779 0-16.263l-4.243 4.242a5.506 5.506 0 010 7.779l-7.899 7.899a5.505 5.505 0 01-7.778 0 5.507 5.507 0 010-7.778l3.109-3.109zm49.709-29.702L47.391.38l-8.092 4.681 41.234 23.806-.001 38.267-33.141 19.134-33.14-19.082-.045-38.304 26.579-15.509-7.99-4.654-24.15 14.032a5.015 5.015 0 00-2.491 4.325v41.847c0 1.779.957 3.438 2.5 4.33l36.239 20.922c.771.445 1.636.668 2.5.668s1.729-.223 2.5-.668l36.239-20.922a5.013 5.013 0 002.5-4.33V27.077a5.011 5.011 0 00-2.5-4.329z"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-signalization",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6226",
    clipPath: "url(#fda)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2908",
    d: "M27.741 21.917l-2.311-1.32a.553.553 0 01-.276-.475V10.077a.553.553 0 01.829-.475l2.3 1.3a.553.553 0 01.276.475V21.43a.553.553 0 01-.818.486z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2910",
    d: "M33.891 7.99a.522.522 0 00-.261-.454L20.7.07a.522.522 0 00-.522 0L7.261 7.52A.522.522 0 007 7.977v24.02a.522.522 0 00.261.457l12.956 7.476a.522.522 0 00.522 0l12.891-7.437a.522.522 0 00.261-.457zM21.443 2.758l9.564 5.519-9.564 5.519zm-2.035.052v10.947l-9.472-5.48zM8.97 10.051l10.438 6.015v7.933L8.97 30.036zm11.508 27.765L9.936 31.723l10.451-6.028 10.647 6.028zm11.469-7.711L21.43 24.051v-7.985l10.517-6.08z",
    fill: "#fff"
  })))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-signalization-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6226",
    clipPath: "url(#fea)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2908",
    d: "M27.741 21.917l-2.311-1.32a.553.553 0 01-.276-.475V10.077a.553.553 0 01.829-.475l2.3 1.3a.553.553 0 01.276.475V21.43a.553.553 0 01-.818.486z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2910",
    d: "M33.891 7.99a.522.522 0 00-.261-.454L20.7.07a.522.522 0 00-.522 0L7.261 7.52A.522.522 0 007 7.977v24.02a.522.522 0 00.261.457l12.956 7.476a.522.522 0 00.522 0l12.891-7.437a.522.522 0 00.261-.457zM21.443 2.758l9.564 5.519-9.564 5.519zm-2.035.052v10.947l-9.472-5.48zM8.97 10.051l10.438 6.015v7.933L8.97 30.036zm11.508 27.765L9.936 31.723l10.451-6.028 10.647 6.028zm11.469-7.711L21.43 24.051v-7.985l10.517-6.08z",
    fill: "#fff"
  })))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "icon-smiley-frustrated",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    className: "ffa",
    d: "M16 0a16 16 0 1016 16A16.018 16.018 0 0016 0zm0 29.34A13.34 13.34 0 1129.34 16 13.356 13.356 0 0116 29.34zm-7.532-14.3l2.992-2.992-2.992-2.987 1.88-1.881 3.933 3.932a1.33 1.33 0 010 1.881l-3.933 3.933zm9.252-2.052a1.33 1.33 0 010-1.881l3.932-3.927 1.881 1.881-2.993 2.992 2.992 2.992-1.881 1.881zM25.079 23.5l-2.395 1.157c-1.032-2.136-3.723-3.571-6.7-3.571s-5.666 1.435-6.7 3.57L6.893 23.5c1.488-3.082 5.058-5.073 9.093-5.073s7.604 1.996 9.093 5.073z"
  }))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "icon-smiley-happy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    className: "fga",
    d: "M16 0a16 16 0 1016 16A16.018 16.018 0 0016 0zm0 29.34A13.34 13.34 0 1129.34 16 13.356 13.356 0 0116 29.34zm-2.674-13.963h-2.66V8.063h2.66zm7.979 0h-2.66V8.063H21.3zm4.44 4.408A10.393 10.393 0 0116 26.1a10.393 10.393 0 01-9.745-6.314l2.46-1.01A7.845 7.845 0 0016 23.439a7.845 7.845 0 007.284-4.664z"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "icon-smiley-like",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    className: "fha",
    d: "M16 0a16 16 0 1016 16A16.018 16.018 0 0016 0zm0 29.34A13.34 13.34 0 1129.34 16 13.356 13.356 0 0116 29.34zM6.635 10.387A2.419 2.419 0 019.94 9.5a2.419 2.419 0 114.191 2.419l-2.419 4.191-4.191-2.418a2.419 2.419 0 01-.886-3.305zm11.171 1.545A2.419 2.419 0 1121.989 9.5a2.419 2.419 0 012.432 4.184l-4.183 2.432zm7.924 7.853a10.392 10.392 0 01-9.744 6.315 10.393 10.393 0 01-9.745-6.314l2.46-1.01a7.845 7.845 0 007.284 4.664 7.846 7.846 0 007.284-4.664z"
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "icon-smiley-neutral",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    className: "fia",
    d: "M16 0a16 16 0 1016 16A16.018 16.018 0 0016 0zm0 29.34A13.34 13.34 0 1129.34 16 13.356 13.356 0 0116 29.34zm-2.674-13.963h-2.66V8.063h2.66zm7.979 0h-2.66V8.063H21.3zM8.09 20.592h15.791v2.66H8.09z"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "icon-smiley-sad",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    className: "fja",
    d: "M16 0a16 16 0 1016 16A16.018 16.018 0 0016 0zm0 29.34A13.34 13.34 0 1129.34 16 13.356 13.356 0 0116 29.34zm-2.674-13.963h-2.66V8.063h2.66zm7.979 0h-2.66V8.063H21.3zm3.774 8.123l-2.395 1.157c-1.032-2.136-3.723-3.571-6.7-3.571s-5.666 1.435-6.7 3.57L6.893 23.5c1.488-3.082 5.058-5.073 9.093-5.073s7.604 1.996 9.093 5.073z"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 70 69.996",
    id: "icon-success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fka{fill:#58ab27}")), /*#__PURE__*/React.createElement("path", {
    className: "fka",
    d: "M66.938 20.697l-4.735 5.313a28.806 28.806 0 11-7.5-11.828l4.21-4.735a35 35 0 108.026 11.248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fka",
    d: "M18.473 26.14l-.619.7a5.758 5.758 0 000 7.576l.615.693s9.11 10.392 12.449 13.985c.252.26 1.086.977 1.086.977a3.248 3.248 0 003.3.441 3.136 3.136 0 001.136-.811l32.524-36.527a3.263 3.263 0 00-.026-4.345c-.072-.082-.154-.16-.236-.242s-.183-.141-.271-.219a3.266 3.266 0 00-4.313.491l-30.4 34.147z"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 25",
    id: "icon-sun",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fla"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fla)",
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.172 7.074a5.1 5.1 0 105.1 5.1 5.1 5.1 0 00-5.1-5.1zm2.967 5.1a2.967 2.967 0 11-2.967-2.968 2.967 2.967 0 012.967 2.968zM5.71 13.389v-2.434H1.094a1.224 1.224 0 000 2.434H5.71zM23.249 10.955h-4.614v2.434h4.615a1.224 1.224 0 000-2.434zM13.389 4.018V1.094a1.224 1.224 0 00-2.434 0V5.71h2.434zM10.955 20.324v2.925a1.224 1.224 0 002.434 0v-4.615h-2.434zM18.792 17.062l-1.2-1.2-1.721 1.722 1.2 1.2 2.068 2.068a1.223 1.223 0 001.721-1.721zM18.792 7.307l2.068-2.068a1.223 1.223 0 00-1.72-1.72l-2.068 2.068-1.2 1.195 1.721 1.721zM5.58 17.051l-2.068 2.068a1.223 1.223 0 001.72 1.72L7.3 18.771l1.2-1.2-1.721-1.721zM5.579 7.293l1.2 1.2 1.717-1.725-1.2-1.2L5.228 3.5a1.223 1.223 0 00-1.72 1.72z"
  })))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 39.973",
    id: "icon-tool",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fma{fill:#0071b9}")), /*#__PURE__*/React.createElement("path", {
    className: "fma",
    d: "M39.121 9.799a3.027 3.027 0 000-4.265L34.437.858a3.088 3.088 0 00-4.272 0l-.587.587 8.954 8.954zM12.567 30.908l-3.5-3.5 2.863-2.866-2.724-2.727-4.853 4.853a6.311 6.311 0 00-1.529 2.485L.101 37.442a1.927 1.927 0 001.83 2.529 1.96 1.96 0 00.6-.1l8.289-2.726a6.354 6.354 0 002.481-1.525l4.853-4.853-2.722-2.725zm-2.952 2.581l-4.667 1.534 1.537-4.671c0-.019.019-.037.027-.056l3.16 3.165a.423.423 0 01-.057.028zM28.066 15.408l6.095-6.095 2.724 2.724-6.095 6.095zM21.841 9.18l6.095-6.095 2.723 2.724-6.094 6.095zM10.803.868a3.093 3.093 0 00-4.266 0L.898 6.511a3.021 3.021 0 000 4.27l28.3 28.3a3.016 3.016 0 004.27 0l5.648-5.648a3.027 3.027 0 000-4.265zm20.524 34.9L4.208 8.647l4.463-4.47 3.2 3.2-1.686 1.695a.964.964 0 001.363 1.356l1.686-1.686 3.482 3.479-1.689 1.686a.964.964 0 101.363 1.362l1.686-1.686 3.478 3.478-1.685 1.681a.964.964 0 001.364 1.359l1.686-1.686 3.477 3.486-1.681 1.689a.964.964 0 101.361 1.365l1.683-1.686 3.455 3.455-1.683 1.686a.964.964 0 101.363 1.362l1.683-1.686 3.226 3.221z"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "icon-tool-black",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.953 93.981l-1.429-.771c-1.436-.774-2.506-1.819-3.369-3.288l-.848-1.444 5.849-21.8 14.458-14.457 5.657 5.656L15.328 70.82l-3.705 13.807 13.394-3.792L38.122 67.73l5.657 5.656-14.578 14.578-21.248 6.017zm85.19-70.689a3.999 3.999 0 000-5.657L78.089 2.58a3.999 3.999 0 00-5.656 0l-2.812 2.812 2.828 2.829-.017.017 15.054 15.054.017-.017 2.828 2.829 2.812-2.812zM78.32 93.828L93.828 78.32a3.997 3.997 0 000-5.656L23.337 2.171a4.003 4.003 0 00-5.657 0L2.171 17.68a3.999 3.999 0 000 5.657l70.493 70.491c.78.781 1.805 1.172 2.828 1.172s2.048-.391 2.828-1.172zM20.508 10.657l64.834 64.835-9.851 9.851-64.834-64.835 9.851-9.851zm29.884 37.78l6.776-6.777a2 2 0 10-2.828-2.828l-6.777 6.777a2 2 0 102.829 2.828zM26.894 24.939l6.777-6.777a2 2 0 10-2.828-2.828l-6.777 6.777a2 2 0 102.828 2.828zm11.749 11.749l6.777-6.777a2 2 0 10-2.828-2.828l-6.777 6.777a2 2 0 102.828 2.828zM62.14 60.186l6.777-6.777a2 2 0 10-2.828-2.828l-6.777 6.777a2 2 0 102.828 2.828zm11.749 11.748l6.776-6.776a2 2 0 10-2.828-2.828l-6.776 6.776a2 2 0 102.828 2.828zm-2.495-57.18l-5.656-5.657-13.517 13.517 5.656 5.657 13.517-13.517zm15.508 15.509l-5.656-5.657-13.517 13.516 5.656 5.657 13.517-13.516z"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 22 18",
    id: "icon-twitter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#foclip0_2070_33760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 2.49a8.603 8.603 0 01-2.473.678A4.326 4.326 0 0020.92.787a8.685 8.685 0 01-2.738 1.046 4.312 4.312 0 00-7.34 3.927 12.23 12.23 0 01-8.88-4.502 4.318 4.318 0 001.334 5.754 4.308 4.308 0 01-1.95-.54v.054A4.318 4.318 0 004.8 10.751c-.37.1-.752.15-1.135.15-.272 0-.544-.026-.81-.08a4.31 4.31 0 004.023 2.992 8.644 8.644 0 01-5.35 1.835c-.344 0-.688-.018-1.03-.057a12.177 12.177 0 006.604 1.943A12.17 12.17 0 0019.36 5.274l-.014-.56A8.602 8.602 0 0021.5 2.49z",
    fill: "#0071B9"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "foclip0_2070_33760"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .47)",
    d: "M0 0h21v17.059H0z"
  }))))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icon-undo",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fpa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "reset",
    clipPath: "url(#fpa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6209",
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2901",
    d: "M10.602 6.838h.164l.423-.068-1.174-3.9-1.513-.549L9.58 5.979l.041.123a1.037 1.037 0 00.981.736z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2902",
    d: "M14.695 5.843a7.37 7.37 0 00-3-4.381l2.443-.177a.273.273 0 00.246-.328l-.028-.123a1.051 1.051 0 00-1.078-.832L9.361.288A.928.928 0 009.02.37a.942.942 0 00-.259.191H8.72a.682.682 0 00-.177.314.628.628 0 00-.014.287.764.764 0 00.273.437l.1.055a6.059 6.059 0 11-3.194.123.682.682 0 00.46-.668.641.641 0 00-.173-.48.655.655 0 00-.66-.177A7.424 7.424 0 007.478 15a7.424 7.424 0 007.206-9.157z"
  }))))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 42 44",
    id: "icon-upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42v44H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fqa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4397",
    d: "M37.881 18.342v-.194l-7.169-7.166h-.1v.027h-19.47v28.623h26.7l.039-18.432h3.82l-.013 18.4a3.853 3.853 0 01-3.849 3.847H10.667a3.346 3.346 0 01-3.342-3.342V10.532a3.346 3.346 0 013.342-3.343h19.944v-.027h.3a3.323 3.323 0 012.362.977l7.449 7.446a3.32 3.32 0 01.979 2.367v.389h-3.82zm-8.763 7.751l3.467 3.721a3.816 3.816 0 00.191-5.4l-3.691-3.957zm-2.566-7.608a1.91 1.91 0 00-3.325-1.27l-6.616 7.325a3.7 3.7 0 00-1 2.741 3.781 3.781 0 001.25 2.64l5.906-6.512.072 9.833a1.91 1.91 0 003.82-.026l-.068-9.833-.039-4.898zM23.717 0H5.73A5.736 5.736 0 000 5.73v26.71a3.855 3.855 0 003.85 3.85l-.03-3.85V5.73a1.912 1.912 0 011.91-1.91h21.806A3.823 3.823 0 0023.717 0z",
    fill: "#0071b9"
  })))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 18",
    id: "icon-username",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fra"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7528",
    clipPath: "url(#fra)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7527",
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3890",
    d: "M9.99 10.341a5.171 5.171 0 10-5.172-5.17 5.176 5.176 0 005.172 5.17zm0-8.687A3.516 3.516 0 116.474 5.17 3.52 3.52 0 019.99 1.655z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3891",
    d: "M14.478 11.817h-9.1A5.384 5.384 0 000 17.195h1.655a3.727 3.727 0 013.723-3.728h9.1a3.727 3.727 0 013.722 3.728h1.655a5.383 5.383 0 00-5.377-5.378z"
  }))))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 84",
    id: "icon-vertical-panels",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fsa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h74v84H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7189",
    clipPath: "url(#fsa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2434",
    d: "M62.72 77.971H49.757V6.132H62.72a5 5 0 015 5v61.839a5 5 0 01-5 5z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2435",
    fill: "#e0e4e6",
    d: "M47.191 77.985H26.662V6.146h20.529z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2436",
    d: "M24.095 77.971H11.239a5 5 0 01-5-5V11.132a5 5 0 015-5h12.856v71.839z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3485",
    d: "M6.019 83.117h61.815c2.76 0 5.019-2.581 5.019-5.735V6.736c0-3.154-2.258-5.735-5.019-5.735H6.019C3.259 1.001 1 3.582 1 6.736v70.646c0 3.154 2.258 5.735 5.019 5.735zM5.751 3.566H68.1a2.7 2.7 0 012.506 2.863v71.258a2.7 2.7 0 01-2.506 2.864H5.749a2.7 2.7 0 01-2.506-2.864V6.429a2.7 2.7 0 012.508-2.863z",
    fill: "#a9b7c0"
  })))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 84",
    id: "icon-vertical-panels-active",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h74v84H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7189",
    clipPath: "url(#fta)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2434",
    d: "M62.72 77.971H49.757V6.132H62.72a5 5 0 015 5v61.839a5 5 0 01-5 5z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2435",
    fill: "#98caec",
    d: "M47.191 77.985H26.662V6.146h20.529z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2436",
    d: "M24.095 77.971H11.239a5 5 0 01-5-5V11.132a5 5 0 015-5h12.856v71.839z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3485",
    d: "M6.019 83.117h61.815c2.76 0 5.019-2.581 5.019-5.735V6.736c0-3.154-2.258-5.735-5.019-5.735H6.019C3.259 1.001 1 3.582 1 6.736v70.646c0 3.154 2.258 5.735 5.019 5.735zM5.751 3.566H68.1a2.7 2.7 0 012.506 2.863v71.258a2.7 2.7 0 01-2.506 2.864H5.749a2.7 2.7 0 01-2.506-2.864V6.429a2.7 2.7 0 012.508-2.863z",
    fill: "#0071b9"
  })))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 40 55",
    id: "icon-wall-a",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v55H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6074",
    clipPath: "url(#fua)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.355 14.271v28.115l13.881 7.894V22.289L5.355 14.271z",
    fill: "#2D71B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.682 11.578v31.865a.7.7 0 00.352.6l17.073 9.863a.7.7 0 00.7 0l17.159-9.903a.699.699 0 00.352-.6V11.556a.7.7 0 00-.352-.6L20.832 1.095a.7.7 0 00-.7 0L3.018 10.978a.7.7 0 00-.336.6zm2.673 30.809V14.272l13.881 8.018v28.115L5.355 42.387zm13.881-23.101l-12.68-7.314 12.68-7.334v14.648zm2.694 30.97V35.819l12.514 7.21-12.514 7.227zm0-17.445V22.269l13.881-8v26.587L21.93 32.811zm0-13.591V4.721l12.555 7.251L21.93 19.22z",
    fill: "#E3E5E6"
  })))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 55",
    id: "icon-wall-b",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v55H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6060",
    clipPath: "url(#fva)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2920",
    d: "M37.636 11.578v31.865a.7.7 0 01-.352.6l-17.073 9.863a.7.7 0 01-.7 0L2.352 44.003a.7.7 0 01-.352-.6V11.556a.7.7 0 01.352-.6l17.134-9.861a.7.7 0 01.7 0L37.3 10.978a.7.7 0 01.336.6zm-2.673 30.809V14.272L21.082 22.29v28.115zM21.082 19.286l12.68-7.314-12.68-7.334zm-2.694 30.97V35.819l-12.514 7.21zm0-17.445V22.269l-13.881-8v26.587zm0-13.591V4.721L5.833 11.972z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2921",
    d: "M34.963 14.271v28.115L21.082 50.28V22.289z",
    fill: "#0172b9"
  })))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 55",
    id: "icon-wall-c",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fwa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v55H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6074",
    clipPath: "url(#fwa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2963",
    d: "M37.636 11.578v31.865a.7.7 0 01-.352.6l-17.073 9.863a.7.7 0 01-.7 0L2.352 44.003a.7.7 0 01-.352-.6V11.556a.7.7 0 01.352-.6l17.134-9.861a.7.7 0 01.7 0L37.3 10.978a.7.7 0 01.336.6zm-2.694 29.255V14.272l-13.86 8.018v10.545zm-13.881 9.572l12.763-7.376-12.742-7.21zm0-31.119l12.68-7.314-12.659-7.334zm-2.673 30.97V35.819l-12.514 7.21zm0-17.445V22.269l-13.881-8v26.587zm0-13.591V4.721L5.833 11.972z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2964",
    d: "M34.963 14.271v26.582l-13.881-8.018V22.289z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2965",
    d: "M33.741 11.951l-12.659 7.334V4.637z",
    fill: "#0172b9"
  })))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 55",
    id: "icon-wall-d",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v55H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6072",
    clipPath: "url(#fxa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2957",
    d: "M37.636 11.578v31.865a.7.7 0 01-.352.6l-17.073 9.863a.7.7 0 01-.7 0L2.352 44.003a.7.7 0 01-.352-.6V11.556a.7.7 0 01.352-.6l17.134-9.861a.7.7 0 01.7 0L37.3 10.978a.7.7 0 01.336.6zm-2.694 29.255V14.272l-13.86 8.018v10.545zm-13.881 9.572l12.763-7.376-12.742-7.21zm0-31.119l12.68-7.314-12.659-7.334zm-2.673 30.97V35.819l-12.514 7.21zm0-17.445V22.269l-13.881-8v26.587zm0-13.591V4.721L5.833 11.972z",
    fill: "#e0e4e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2958",
    d: "M18.388 32.503v.311L4.507 40.853V14.271l13.881 8z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2959",
    d: "M18.388 4.699v14.524L5.812 11.95z",
    fill: "#0172b9"
  })))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-walls",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 10",
    clipPath: "url(#fya)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6079"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2974",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.453zm-2.033 22.079V10.017L21.4 16.068v7.959zm-10.476 7.224l9.632-5.567-9.618-5.441zm0-23.486l9.57-5.52L21.4 2.746zm-2.017 23.376v-10.9L9.924 31.72zm0-13.166v-7.955L8.892 10.017v20.061zm0-10.258V2.808L9.893 8.281z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2975",
    d: "M31.877 10.016v20.062l-10.476-6.052v-7.959z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2976",
    d: "M30.955 8.265L21.401 13.8V2.745z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2977",
    d: "M19.368 23.776v.235L8.892 30.078V10.016l10.476 6.036z",
    fill: "#0172b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2978",
    d: "M19.368 2.792v10.961L9.877 8.265z",
    fill: "#0172b9"
  }))))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "icon-walls-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 10",
    clipPath: "url(#fza)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6079"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2974",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.453zm-2.033 22.079V10.017L21.4 16.068v7.959zm-10.476 7.224l9.632-5.567-9.618-5.441zm0-23.486l9.57-5.52L21.4 2.746zm-2.017 23.376v-10.9L9.924 31.72zm0-13.166v-7.955L8.892 10.017v20.061zm0-10.258V2.808L9.893 8.281z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2975",
    d: "M31.877 10.016v20.062l-10.476-6.052v-7.959z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2976",
    d: "M30.955 8.265L21.401 13.8V2.745z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2977",
    d: "M19.368 23.776v.235L8.892 30.078V10.016l10.476 6.036z",
    fill: "#98caec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2978",
    d: "M19.368 2.792v10.961L9.877 8.265z",
    fill: "#98caec"
  }))))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-weather",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.419 12.798a4.897 4.897 0 00-9.091.044 4.896 4.896 0 00.662 9.749h8.39a4.895 4.895 0 10.04-9.792l-.001-.001zm-.04 7.81H4.99a2.915 2.915 0 11.997-5.65 2.914 2.914 0 115.733.342 2.915 2.915 0 014.009 4.12 2.913 2.913 0 01-2.348 1.187l-.002.001zM10.064 8.486a4.81 4.81 0 117.863 4.896l-1.338-1.462a2.827 2.827 0 10-4.622-2.88l-1.903-.554zM23.707 9.83a.989.989 0 01-.989.993h-2.04V8.841h2.037a.99.99 0 01.992.99zm-2.644 4.983a.99.99 0 11-1.4 1.402l-.244-.243-1.197-1.199 1.401-1.401 1.44 1.44zM8.297 4.85a.991.991 0 011.4-1.404l.245.244 1.197 1.2-1.402 1.4-1.44-1.44zm7.371-1.017h-1.98V1.795a.991.991 0 111.983 0v.346l-.003 1.692zm3.951 2.458l-1.401-1.402 1.44-1.44a.991.991 0 011.403 1.4l-.242.245-1.197 1.197h-.003z",
    fill: "#0071B9"
  }))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23 35",
    id: "icon-wheelchair",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23v35H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7765",
    clipPath: "url(#gba)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7764",
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4036",
    d: "M19.586 17.921a3.23 3.23 0 00-3.139-2.453h-5.8a.307.307 0 01-.293-.22L8.815 9.92a2.934 2.934 0 00-3.628-2l2.352 8.144a3.25 3.25 0 003.107 2.337h5.8a.319.319 0 01.305.266l2.094 7.606a2.929 2.929 0 003.6 2.05z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 569",
    cx: 2.93,
    cy: 2.93,
    r: 2.93,
    transform: "translate(3.027)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4037",
    d: "M16.9 29.588A8.187 8.187 0 015.322 18.01a1.465 1.465 0 00-2.072-2.072 11.116 11.116 0 0015.721 15.721 1.465 1.465 0 10-2.071-2.071z"
  }))))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 99.967",
    id: "india_11_10_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v79.9a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067A10.815 10.815 0 012.75 96.9a8.591 8.591 0 01-2.683-6.936V18.109h10l.02 71.609 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc",
    opacity: 0.776
  }))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 99.967",
    id: "india_11_10_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v79.9a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067A10.815 10.815 0 012.75 96.9a8.591 8.591 0 01-2.683-6.936V18.109h10l.02 71.609 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 140.326",
    id: "india_11_13_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v120.262a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 111.968 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc"
  }))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 140.326",
    id: "india_11_13_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v120.262a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 111.968 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 110.22 210.218",
    id: "india_11_20_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.249L100.105 0a10.659 10.659 0 017.095 2.789A11.821 11.821 0 01110.105 10l.1 189.969a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039l-90.038.249a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-181.924h10l.124 181.675h90.018L100.109 10 .067 10.249s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 110.22 210.218",
    id: "india_11_20_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.249L100.105 0a10.659 10.659 0 017.095 2.789A11.821 11.821 0 01110.105 10l.1 189.969a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039l-90.038.249a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-181.924h10l.124 181.675h90.018L100.109 10 .067 10.249s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 110.22 210.218",
    id: "india_13_24_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.249L100.105 0a10.659 10.659 0 017.095 2.789A11.821 11.821 0 01110.105 10l.1 189.969a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039l-90.038.249a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-181.924h10l.124 181.675h90.018L100.109 10 .067 10.249s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 110.22 210.218",
    id: "india_13_24_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.249L100.105 0a10.659 10.659 0 017.095 2.789A11.821 11.821 0 01110.105 10l.1 189.969a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039l-90.038.249a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936l-.1-181.924h10l.124 181.675h90.018L100.109 10 .067 10.249s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "india_16_13_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "india_16_13_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "india_16_15_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "india_16_15_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "india_17_18_22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "india_17_18_22_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 76 38",
    id: "kone-logo",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h76v38H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "logo",
    clipPath: "url(#gqa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6240",
    fill: "#0071b9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3073",
    d: "M0 0v38h17.679V0zm11.456 26.186l-5.012-6.717v6.717h-3.9V12.009h3.9V18.2l4.827-6.189h4.593l-5.332 6.674 5.7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3074",
    d: "M38.877 0v38h17.678V0zm15.344 26.185H52.25l-7.426-7.193v7.193h-3.608V12.009h2.231l7.155 6.924v-6.924h3.619z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6239"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3075",
    d: "M19.443 0v38h17.678V0zm8.839 26.4a7.3 7.3 0 01-7.583-7.4 7.295 7.295 0 017.584-7.4 7.3 7.3 0 017.584 7.4 7.3 7.3 0 01-7.585 7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3076",
    d: "M28.282 14.941A3.761 3.761 0 0024.599 19a3.7 3.7 0 107.367 0 3.763 3.763 0 00-3.684-4.059z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3077",
    d: "M58.32 0v38h17.684V0zm14.416 15.133h-7.211v2.4h6.335v3.04h-6.335v2.4h7.211v3.218H61.668V12.008h11.068z"
  }))))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "main-ceiling",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gra"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 18",
    clipPath: "url(#gra)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6070"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2951",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.453zm-2.033 22.079V10.017L21.4 16.068v7.959zm-10.476 7.224l9.632-5.567-9.618-5.441zm-.938-22.908l10.507-6.114-10.492-6.1-10.57 6.1zm-1.079 22.8v-10.9L9.924 31.72zm0-13.166v-7.957L8.892 10.017v20.061z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2952",
    d: "M30.955 8.267l-10.492 6.112L9.877 8.267l10.586-6.1z",
    fill: "#0172b9"
  }))))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "main-ceiling-selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gsa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Artwork 18",
    clipPath: "url(#gsa)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6070"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2951",
    d: "M33.895 7.984v24.049a.532.532 0 01-.266.453l-12.884 7.443a.532.532 0 01-.532 0L7.266 32.456A.532.532 0 017 32.002V7.968a.532.532 0 01.266-.453L20.2.072a.532.532 0 01.532 0L33.645 7.53a.532.532 0 01.25.453zm-2.033 22.079V10.017L21.4 16.068v7.959zm-10.476 7.224l9.632-5.567-9.618-5.441zm-.938-22.908l10.507-6.114-10.492-6.1-10.57 6.1zm-1.079 22.8v-10.9L9.924 31.72zm0-13.166v-7.957L8.892 10.017v20.061z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2952",
    d: "M30.955 8.267l-10.492 6.112L9.877 8.267l10.586-6.1z",
    fill: "#98caec"
  }))))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "mobile-comm",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.845 53.378l-6.518-3.16c6.917-14.267 7.032-32.078.301-46.482L82.19.67c7.631 16.33 7.499 36.527-.345 52.708zM63.979 11.893c4.337 9.364 4.225 20.915-.291 30.144l6.506 3.184c5.451-11.14 5.588-25.077.357-36.372l-6.572 3.044zM57.382 14v74c0 3.651-2.731 6.621-6.09 6.621h-.823v-.189H38.618c0 .006-5.431.006-5.431.006h-5.431c0-.006-11.851-.006-11.851-.006v.189h-.823c-3.358 0-6.09-2.97-6.09-6.621V14c0-3.651 2.732-6.622 6.09-6.622H51.29c3.36 0 6.092 2.971 6.092 6.622zm-41.146.622v68.947h11.792c0 .014 5.159-.006 5.159-.006l5.159.02c0-.014 11.792-.014 11.792-.014l.001-68.947H16.236zM37.262 89a4.074 4.074 0 10-8.148 0 4.074 4.074 0 008.148 0z",
    fill: "#0071B9"
  }))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "music",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.632 27.077v41.846c0 1.781-.958 3.44-2.5 4.33L49.893 94.175c-.771.445-1.636.668-2.5.668s-1.729-.223-2.5-.668L8.653 73.253a5.016 5.016 0 01-2.5-4.33V27.076c0-1.776.955-3.434 2.491-4.325L32.795 8.719l7.99 4.654-26.579 15.509.045 38.304 33.14 19.082 33.141-19.134.001-38.267L39.298 5.061 47.39.38l38.741 22.368a5.01 5.01 0 012.501 4.329zM55.213 51.229c-3.314.708-6 3.879-6 7.083 0 1.466.568 2.681 1.496 3.503a5.09 5.09 0 001.498 1.861c.925.71 2.067 1.078 3.275 1.078.534 0 1.081-.072 1.628-.219 3.066-.822 5.483-3.823 5.638-6.921.015-.003.015-19.128.015-19.128V31.491c0-.92-.408-1.782-1.119-2.366a3.044 3.044 0 00-2.537-.638l-21.653 4.277a3.068 3.068 0 00-2.472 3.005V55.29a7.349 7.349 0 00-2.092.888c-2.963 1.008-5.228 4.038-5.228 7.099 0 1.76.745 3.341 2.045 4.338.925.709 2.067 1.078 3.275 1.078.534 0 1.081-.072 1.628-.219 2.267-.608 4.176-2.407 5.084-4.555.942-1.226 1.518-2.694 1.518-4.172V42.78l16-3v11.377a5.86 5.86 0 00-1.999.072z",
    fill: "#0071B9"
  }))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 99.967",
    id: "nanospace_11_10_21",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v79.9a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067A10.815 10.815 0 012.75 96.9a8.591 8.591 0 01-2.683-6.936V18.109h10l.02 71.609 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc",
    opacity: 0.776
  }))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 99.967",
    id: "nanospace_11_10_21_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v79.9a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067A10.815 10.815 0 012.75 96.9a8.591 8.591 0 01-2.683-6.936V18.109h10l.02 71.609 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "office",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5 53.455v34.378a6.012 6.012 0 01-6.006 6.005H58.125v-8H71.5V54.955l-20.917-6.056c-.153.114-.311.234-.465.355v38.819l-.64.991c-1.006 1.557-2.783 3.189-4.007 4.048l-1.034.725H22.505a6.01 6.01 0 01-6.005-6.005V14.458a5.995 5.995 0 014.981-5.918L59.62 1.938l1.354.952c1.206.848 3.076 2.382 4.121 3.482l1.099 1.158v21.66a7.946 7.946 0 01-2.345 5.66 7.917 7.917 0 01-5.655 2.336l.004-7.996c-.004 0-.004-18.321-.004-18.321a31.442 31.442 0 00-.56-.467L24.5 16.137v69.701h17.251c.126-.118.25-.239.367-.358V45.806l1.149-1.167c1.005-1.021 3.281-2.868 4.94-3.678l1.386-.676 25.571 7.403a6.03 6.03 0 014.336 5.767z",
    fill: "#0071B9"
  }))), _symbol179 || (_symbol179 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "robot",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.977 19v9h-8v-9h8zm16.046 0v9h8v-9h-8zM25 37.709v6.033l2.687.282c6.563.69 13.397 1.04 20.313 1.04 10.403 0 20.412-.778 29.762-2.304l.002.102 8-1.572v-8.742C85.764 15.704 72.06 2 55.215 2h-14.43C23.941 2 10.237 15.704 10.237 32.548v44.08c0 6.617 5.383 12 12 12H24V91c0 2.757 2.243 5 5 5h2c2.757 0 5-2.243 5-5v-2.372h24V91c0 2.757 2.243 5 5 5h2c2.757 0 5-2.243 5-5v-2.372h1.764c6.617 0 12-5.383 12-12V47.63l-8.101 1.022v27.975h.101c0 2.206-1.794 4-4 4H22.237c-2.206 0-4-1.794-4-4v-44.08C18.237 20.115 28.352 10 40.785 10h14.43c12.274 0 22.289 9.857 22.544 22.071h-.078v4.555C68.491 38.18 58.313 39 48 39c-6.709 0-13.333-.339-19.686-1.007L25 37.709z",
    fill: "#0071B9"
  }))), _symbol180 || (_symbol180 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 54 54.845",
    id: "single",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gza",
    x: 7.454,
    y: 17.492,
    width: 39.157,
    height: 26.428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "single entrance"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11544",
    d: "M4.592 48.322V7.129a3.571 3.571 0 01.656-1.7 2.966 2.966 0 011.884-.775l21.667.014v2.458H7.133l-.048 41.193h10.157v2.466H7.085a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.802z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11546",
    d: "M.005 52.379L0 2.472a3.565 3.565 0 01.655-1.7 2.966 2.966 0 011.884-.775l26.26.014v2.458H2.905a.588.588 0 00-.25.093.377.377 0 00-.115.2l-.042 49.355.108.139.182.119H17.18v2.466H2.498a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.801z",
    fill: "#aaafb3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11547",
    d: "M49.349 7.12l.014 41.193a2.257 2.257 0 01-.725 1.816 2.592 2.592 0 01-1.747.644h-9.988v-2.46h9.988V7.171L28.804 7.12V4.654l18.083.049a2.438 2.438 0 011.846.744 2.259 2.259 0 01.616 1.673z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11548",
    d: "M53.994 52.379l.005-49.907a3.565 3.565 0 00-.655-1.7 2.966 2.966 0 00-1.884-.775H28.799v2.458l22.3.014a.588.588 0 01.25.093.377.377 0 01.115.2l.037 49.355-.108.139-.182.119H36.819v2.466h14.682a3.179 3.179 0 001.826-.661 3.094 3.094 0 00.667-1.801z",
    fill: "#aaafb3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#gza)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11549",
    d: "M31.117 31.206l-3.826-5.308H30.3l2.155 2.985 2.155-2.985h3.006l-3.828 5.308a1.608 1.608 0 01-2.671 0zm-9.2-4.769l2.378 3.073h3.083l-4.124-5.34a1.654 1.654 0 00-2.674 0l-4.124 5.34h3.083z",
    fill: "#0071b9"
  }))))), _symbol181 || (_symbol181 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 54 54.845",
    id: "single_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "haa",
    x: 7.454,
    y: 17.492,
    width: 39.157,
    height: 26.428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "single entrance - selected"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11544",
    d: "M4.592 48.322V7.129a3.571 3.571 0 01.656-1.7 2.966 2.966 0 011.884-.775l21.667.014v2.458H7.133l-.048 41.193h10.157v2.466H7.085a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.802z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11546",
    d: "M.005 52.379L0 2.472a3.565 3.565 0 01.655-1.7 2.966 2.966 0 011.884-.775l26.26.014v2.458H2.905a.588.588 0 00-.25.093.377.377 0 00-.115.2l-.042 49.355.108.139.182.119H17.18v2.466H2.498a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.801z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11547",
    d: "M49.349 7.12l.014 41.193a2.257 2.257 0 01-.725 1.816 2.592 2.592 0 01-1.747.644h-9.988v-2.46h9.988V7.171L28.804 7.12V4.654l18.083.049a2.438 2.438 0 011.846.744 2.259 2.259 0 01.616 1.673z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11548",
    d: "M53.994 52.379l.005-49.907a3.565 3.565 0 00-.655-1.7 2.966 2.966 0 00-1.884-.775H28.799v2.458l22.3.014a.588.588 0 01.25.093.377.377 0 01.115.2l.037 49.355-.108.139-.182.119H36.819v2.466h14.682a3.179 3.179 0 001.826-.661 3.094 3.094 0 00.667-1.801z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#haa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11549",
    d: "M31.117 31.206l-3.826-5.308H30.3l2.155 2.985 2.155-2.985h3.006l-3.828 5.308a1.608 1.608 0 01-2.671 0zm-9.2-4.769l2.378 3.073h3.083l-4.124-5.34a1.654 1.654 0 00-2.674 0l-4.124 5.34h3.083z",
    fill: "#0071b9"
  }))))), _symbol182 || (_symbol182 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 140.326",
    id: "square",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v120.262a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 111.968 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc"
  }))), _symbol183 || (_symbol183 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 140.326",
    id: "square_10_13_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v120.262a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 111.968 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc"
  }))), _symbol184 || (_symbol184 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 140.326",
    id: "square_10_13_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v120.262a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 111.968 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol185 || (_symbol185 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 109.831 140.326",
    id: "square_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h89.754a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v120.262a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 111.968 89.734.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol186 || (_symbol186 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 96 96",
    id: "statistics",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.805 79.865v8H11.719a4 4 0 01-4-4V6.78h8v73.085h73.086zM58.688 16.75h-12v56.936h12V16.75zM37.281 53.207h-12v20.479h12V53.207zM79.81 35.29h-12v38.396h12V35.29z",
    fill: "#0071B9"
  }))), _symbol187 || (_symbol187 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "status-success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.75,
    fill: "#1ED273"
  }))), _symbol188 || (_symbol188 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 132.101 248.238",
    id: "transys_12_23_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.109-1.302h107.959a12.821 19.237 0 018.534 5.033 14.219 21.334 0 013.494 13.014v217.043a11.374 17.066 0 01-3.323 12.562 13.489 20.238 0 01-8.705 5.485H12.108a13.009 19.518 0 01-8.8-5.53A10.334 15.505 0 01.08 233.788V31.265H12.11l.024 202.073 107.935.45V16.745H.082s-.91-5.185 3.35-12.326c4.262-7.141 8.677-5.721 8.677-5.721z",
    fill: "#c6cacc"
  }))), _symbol189 || (_symbol189 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 132.101 248.238",
    id: "transys_12_23_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.109-1.302h107.959a12.821 19.237 0 018.534 5.033 14.219 21.334 0 013.494 13.014v217.043a11.374 17.066 0 01-3.323 12.562 13.489 20.238 0 01-8.705 5.485H12.108a13.009 19.518 0 01-8.8-5.53A10.334 15.505 0 01.08 233.788V31.265H12.11l.024 202.073 107.935.45V16.745H.082s-.91-5.185 3.35-12.326c4.262-7.141 8.677-5.721 8.677-5.721z",
    fill: "#338dc7"
  }))), _symbol190 || (_symbol190 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 132.101 280.62",
    id: "transys_12_26_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.109-1.287h107.959a12.821 21.746 0 018.534 5.69 14.219 24.117 0 013.494 14.712v245.354a11.374 19.292 0 01-3.323 14.201 13.489 22.878 0 01-8.705 6.2H12.108a13.009 22.064 0 01-8.8-6.25A10.334 17.527 0 01.08 264.468V35.528H12.11l.024 228.433 107.935.508V19.115H.082s-.91-5.862 3.35-13.935c4.262-8.073 8.677-6.467 8.677-6.467z",
    fill: "#c6cacc"
  }))), _symbol191 || (_symbol191 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 132.101 280.62",
    id: "transys_12_26_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.109-1.287h107.959a12.821 21.746 0 018.534 5.69 14.219 24.117 0 013.494 14.712v245.354a11.374 19.292 0 01-3.323 14.201 13.489 22.878 0 01-8.705 6.2H12.108a13.009 22.064 0 01-8.8-6.25A10.334 17.527 0 01.08 264.468V35.528H12.11l.024 228.433 107.935.508V19.115H.082s-.91-5.862 3.35-13.935c4.262-8.073 8.677-6.467 8.677-6.467z",
    fill: "#338dc7"
  }))), _symbol192 || (_symbol192 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 140.238 240.258",
    id: "transys_14_24_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.811.193l114.57-.284a13.563 12.193 0 019.028 3.19 15.042 13.522 0 013.697 8.249l.127 217.304a12.032 10.817 0 01-3.516 7.963 14.27 12.828 0 01-9.209 3.476l-114.57.285a13.762 12.371 0 01-9.31-3.505 10.932 9.827 0 01-3.414-7.934L.086 20.835h12.725l.158 207.817h114.544l-.127-217.304-127.3.284S-.877 8.346 3.631 3.82C8.14-.707 12.811.193 12.811.193z",
    fill: "#c6cacc"
  }))), _symbol193 || (_symbol193 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 140.238 240.258",
    id: "transys_14_24_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.811.193l114.57-.284a13.563 12.193 0 019.028 3.19 15.042 13.522 0 013.697 8.249l.127 217.304a12.032 10.817 0 01-3.516 7.963 14.27 12.828 0 01-9.209 3.476l-114.57.285a13.762 12.371 0 01-9.31-3.505 10.932 9.827 0 01-3.414-7.934L.086 20.835h12.725l.158 207.817h114.544l-.127-217.304-127.3.284S-.877 8.346 3.631 3.82C8.14-.707 12.811.193 12.811.193z",
    fill: "#338dc7"
  }))), _symbol194 || (_symbol194 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 150.256 270.289",
    id: "transys_15_27_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.726.229l122.755-.32a14.532 13.717 0 019.673 3.589 16.116 15.212 0 013.96 9.28l.137 244.466a12.892 12.169 0 01-3.767 8.958 15.289 14.431 0 01-9.867 3.91l-122.755.321a14.745 13.918 0 01-9.975-3.943 11.713 11.056 0 01-3.658-8.926L.093 23.451h13.633l.17 233.793h122.727l-.137-244.467-136.393.32S-.94 9.402 3.89 4.309C8.72-.784 13.726.23 13.726.23z",
    fill: "#c6cacc"
  }))), _symbol195 || (_symbol195 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 150.256 270.289",
    id: "transys_15_27_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.726.229l122.755-.32a14.532 13.717 0 019.673 3.589 16.116 15.212 0 013.96 9.28l.137 244.466a12.892 12.169 0 01-3.767 8.958 15.289 14.431 0 01-9.867 3.91l-122.755.321a14.745 13.918 0 01-9.975-3.943 11.713 11.056 0 01-3.658-8.926L.093 23.451h13.633l.17 233.793h122.727l-.137-244.467-136.393.32S-.94 9.402 3.89 4.309C8.72-.784 13.726.23 13.726.23z",
    fill: "#338dc7"
  }))), _symbol196 || (_symbol196 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 54 54.845",
    id: "ttc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hpa",
    x: 7.454,
    y: 17.492,
    width: 39.157,
    height: 26.428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "trough car type"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11544",
    d: "M4.592 48.322V7.129a3.571 3.571 0 01.656-1.7 2.966 2.966 0 011.884-.775l10.2.014v2.458H7.133l-.048 41.193h10.157v2.466H7.085a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.802z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11546",
    d: "M.005 52.379L0 2.472a3.565 3.565 0 01.655-1.7 2.966 2.966 0 011.884-.775l14.762.014v2.458H2.905a.588.588 0 00-.25.093.377.377 0 00-.115.2l-.042 49.355.108.139.182.119H17.18v2.466H2.498a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.801z",
    fill: "#aaafb3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11547",
    d: "M49.349 7.12l.014 41.193a2.257 2.257 0 01-.725 1.816 2.592 2.592 0 01-1.747.644h-9.988v-2.46h9.988V7.171L36.404 7.12V4.654l10.483.049a2.438 2.438 0 011.846.744 2.259 2.259 0 01.616 1.673z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11548",
    d: "M53.995 52.379L54 2.472a3.565 3.565 0 00-.655-1.7 2.966 2.966 0 00-1.884-.775H36.442v2.458l14.653.014a.588.588 0 01.25.093.377.377 0 01.115.2l.043 49.355-.108.139-.182.119H36.82v2.466h14.683a3.179 3.179 0 001.826-.661 3.094 3.094 0 00.666-1.801z",
    fill: "#aaafb3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#hpa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11549",
    d: "M31.117 31.206l-3.826-5.308H30.3l2.155 2.985 2.155-2.985h3.006l-3.828 5.308a1.608 1.608 0 01-2.671 0zm-9.2-4.769l2.378 3.073h3.083l-4.124-5.34a1.654 1.654 0 00-2.674 0l-4.124 5.34h3.083z",
    fill: "#0071b9"
  }))))), _symbol197 || (_symbol197 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 54 54.845",
    id: "ttc_ena",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hqa",
    x: 7.454,
    y: 17.492,
    width: 39.157,
    height: 26.428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "trough car type - ENA"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11544",
    d: "M4.592 48.322V7.129a3.571 3.571 0 01.656-1.7 2.966 2.966 0 011.884-.775l1.687.014v2.458H7.133l-.048 41.193H28.8v2.466H7.085a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.802z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11546",
    d: "M.005 52.379L0 2.472a3.565 3.565 0 01.655-1.7 2.966 2.966 0 011.884-.775l6.28.014v2.458H2.905a.588.588 0 00-.25.093.377.377 0 00-.115.2l-.042 49.355.108.139.182.119H28.8v2.466H2.498a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.801z",
    fill: "#aaafb3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11547",
    d: "M49.349 7.12l.014 41.193a2.257 2.257 0 01-.725 1.816 2.592 2.592 0 01-1.747.644H45.18v-2.46h1.711V7.171L28.804 7.12V4.654l18.083.049a2.438 2.438 0 011.846.744 2.259 2.259 0 01.616 1.673z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11548",
    d: "M53.994 52.379l.005-49.907a3.565 3.565 0 00-.655-1.7 2.966 2.966 0 00-1.884-.775H28.799v2.458l22.3.014a.588.588 0 01.25.093.377.377 0 01.115.2l.037 49.355-.108.139-.182.119h-6.032v2.466h6.322a3.179 3.179 0 001.826-.661 3.094 3.094 0 00.667-1.801z",
    fill: "#aaafb3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#hqa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11549",
    d: "M31.117 31.206l-3.826-5.308H30.3l2.155 2.985 2.155-2.985h3.006l-3.828 5.308a1.608 1.608 0 01-2.671 0zm-9.2-4.769l2.378 3.073h3.083l-4.124-5.34a1.654 1.654 0 00-2.674 0l-4.124 5.34h3.083z",
    fill: "#0071b9"
  }))))), _symbol198 || (_symbol198 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 54 54.845",
    id: "ttc_ena_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hra",
    x: 7.454,
    y: 17.492,
    width: 39.157,
    height: 26.428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "trough car type - ENA - selected"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11544",
    d: "M4.592 48.322V7.129a3.571 3.571 0 01.656-1.7 2.966 2.966 0 011.884-.775l1.687.014v2.458H7.133l-.048 41.193H28.8v2.466H7.085a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.802z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11546",
    d: "M.005 52.379L0 2.472a3.565 3.565 0 01.655-1.7 2.966 2.966 0 011.884-.775l6.28.014v2.458H2.905a.588.588 0 00-.25.093.377.377 0 00-.115.2l-.042 49.355.108.139.182.119H28.8v2.466H2.498a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.801z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11547",
    d: "M49.349 7.12l.014 41.193a2.257 2.257 0 01-.725 1.816 2.592 2.592 0 01-1.747.644H45.18v-2.46h1.711V7.171L28.804 7.12V4.654l18.083.049a2.438 2.438 0 011.846.744 2.259 2.259 0 01.616 1.673z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11548",
    d: "M53.994 52.379l.005-49.907a3.565 3.565 0 00-.655-1.7 2.966 2.966 0 00-1.884-.775H28.799v2.458l22.3.014a.588.588 0 01.25.093.377.377 0 01.115.2l.037 49.355-.108.139-.182.119h-6.032v2.466h6.322a3.179 3.179 0 001.826-.661 3.094 3.094 0 00.667-1.801z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#hra)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11549",
    d: "M31.117 31.206l-3.826-5.308H30.3l2.155 2.985 2.155-2.985h3.006l-3.828 5.308a1.608 1.608 0 01-2.671 0zm-9.2-4.769l2.378 3.073h3.083l-4.124-5.34a1.654 1.654 0 00-2.674 0l-4.124 5.34h3.083z",
    fill: "#0071b9"
  }))))), _symbol199 || (_symbol199 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 54 54.845",
    id: "ttc_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hsa",
    x: 7.454,
    y: 17.492,
    width: 39.157,
    height: 26.428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "trough car type -selected"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11544",
    d: "M4.592 48.322V7.129a3.571 3.571 0 01.656-1.7 2.966 2.966 0 011.884-.775l10.2.014v2.458H7.133l-.048 41.193h10.157v2.466H7.085a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.802z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11546",
    d: "M.005 52.379L0 2.472a3.565 3.565 0 01.655-1.7 2.966 2.966 0 011.884-.775l14.762.014v2.458H2.905a.588.588 0 00-.25.093.377.377 0 00-.115.2l-.042 49.355.108.139.182.119H17.18v2.466H2.498a3.179 3.179 0 01-1.826-.661 3.094 3.094 0 01-.667-1.801z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11547",
    d: "M49.349 7.12l.014 41.193a2.257 2.257 0 01-.725 1.816 2.592 2.592 0 01-1.747.644h-9.988v-2.46h9.988V7.171L36.404 7.12V4.654l10.483.049a2.438 2.438 0 011.846.744 2.259 2.259 0 01.616 1.673z",
    fill: "#c6cacc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11548",
    d: "M53.995 52.379L54 2.472a3.565 3.565 0 00-.655-1.7 2.966 2.966 0 00-1.884-.775H36.442v2.458l14.653.014a.588.588 0 01.25.093.377.377 0 01.115.2l.043 49.355-.108.139-.182.119H36.82v2.466h14.683a3.179 3.179 0 001.826-.661 3.094 3.094 0 00.666-1.801z",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#hsa)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11549",
    d: "M31.117 31.206l-3.826-5.308H30.3l2.155 2.985 2.155-2.985h3.006l-3.828 5.308a1.608 1.608 0 01-2.671 0zm-9.2-4.769l2.378 3.073h3.083l-4.124-5.34a1.654 1.654 0 00-2.674 0l-4.124 5.34h3.083z",
    fill: "#0071b9"
  }))))), _symbol200 || (_symbol200 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 41 55",
    id: "vision-panel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.493 1.01v28.9L40.5 39.546v-28.89L24.493 1.01z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 44.355L16.507 54 40.5 39.546 24.493 29.91.5 44.355z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 38.084V25.476l2.25 1.356V39.44l-2.25-1.356zM3.377 33.266V20.658l2.25 1.356v12.608l-2.25-1.356z",
    fill: "#ECF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 44.355l16.007-9.627",
    stroke: "#929497",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.504 20.283v28.9L16.507 54V25.1l-8.003-4.818zm2.877 17.801V25.476l2.25 1.356V39.44l-2.25-1.356zM.5 15.465v28.9l8.004 4.817v-28.9L.5 15.466zm2.877 17.8V20.659l2.25 1.356v12.608l-2.25-1.356z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 10.656L16.507 25.101M40.5 10.656L16.507 25.101v28.9L40.5 39.546v-28.89zM.5 15.445l16.007 9.646L40.5 10.637 24.493 1 .5 15.445zM8.504 20.283v28.9",
    stroke: "#404041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 15.465v28.89L16.507 54V25.101L.5 15.465z",
    stroke: "#404041",
    strokeLinejoin: "round"
  }))), _symbol201 || (_symbol201 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "wide",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol202 || (_symbol202 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 50 59",
    id: "wide_16_20_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 59,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA7CAYAAAA5MNl5AAAD6klEQVRogWJ8+eoV08PHT+P//fuX++//fzkGBgZGhqEDPrKwsMzn5+frBAAAAP//Ynn09FnSn79/ZzIwMDANIQ/AgNCfP38aP378xAoAAAD//2L5/edvATQW/g8Ot5EEQO5m/PPnTw4AAAD//2J8+PiJJgMDAzNI9Nu372w/fv5kGwo+YGZmkvvy9dtycEpiYGAAAAAA//8aSvkBBTx++lzj8dOnV8EeYWBgAAAAAP//Ynn4+KkGJEb+M3BycjwQExH5OnicSyRgYGAAAAAA//9iefr8+SEGBgaR/wwM/wX5+V0YGBj2DwmXIwMGBgYAAAAA//9igdKM4FwzONxEOmBgYAAAAAD//xqKRS4mYGBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//GrIe+fDhAze8d87AwAAAAAD//xqyHvn99y94LA4MGBgYAAAAAP//Gh5Ji4GBAQAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//gq3XAoP/DAyCt+/ek2RkYmL99euX0GBev/Xj5y8VOIeBgQEAAAD//wJ55DuUzfjx06cljIyM//7//8/479+/wb5IkxEEwCwGhq8AAAAA//9iYWZmnvL3799OkMT///85//+HrJpFqBn8gIWFeSEAAAD//2Lh5+Pt+/z5C9PvP3/KGRgYeJCc/XcI+OEvExPTBn4+/nIAAAAA//8DAMQVdJybo2uXAAAAAElFTkSuQmCC"
  }))), _symbol203 || (_symbol203 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 50 59",
    id: "wide_16_20_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 59,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA7CAYAAAA5MNl5AAAD5ElEQVRogWLs232D5d6rTzPvf/oX+enXfw6GIQTYmRn/KvEzHVIQ4vAHAAAA//9iuf/609wTL/7G/R9KPoCCb3/+s5x79dfp//8f2wAAAAD//2K5/eFfOEiQcTC4jEQACnwQvv7+rw0AAAD//2KxkuMJ/s/AwAqS+P37D9efP3+5hoInfv9n0D74+FcByCPf/zAwAgAAAP//GooRAQYtW695bbjxcSs4SzAwMAAAAAD//2Jp3nLVCxIj/xl4OFiPF7movxpgN5IOGBgYAAAAAP//Ytl979Pmb78ZmEAcFwWOIgYGhv4h5gcGBgYGBgAAAAD//wJ7YCiWWCiAgYEBAAAA//8Ce2TIAwYGBgAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xoeHmFgYAAAAAD//xqyHvn+44cQnMPAwAAAAAD//xqyHvn7/z94LA4MGBgYAAAAAP//Gh5Ji4GBAQAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//Gh4eYWBgAAAAAP//YkHm/P3PINm8+ZLBPwZGjt9//sgPnLMIgy8//xrDVTEwMAAAAAD//2J0mnzi98df/8EeYmViYGAErXL8z8DwZwisRvsHdSMbMwMDAAAA//9iUhVg2glbofn7HwPDr78MDL/+QRQNdgwDagJMVwAAAAD//2KRE2QPYmD4ueHqu78ev/4ilv8yDYH1p6DUo8jH9EBZmNMFAAAA//8DAJ9lyvJaz3WnAAAAAElFTkSuQmCC"
  }))), _symbol204 || (_symbol204 = /*#__PURE__*/React.createElement("symbol", {
    id: "wide_23_17_26",
    viewBox: "0 0 193 140",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, ".hxst0{fill:#c6cacc}"), /*#__PURE__*/React.createElement("path", {
    className: "hxst0",
    d: "M183.32 140H10.12C4.54 140 0 135.46 0 129.88V18.12h10.12v111.76h173.2V10.12H0C0 4.54 4.54 0 10.12 0h173.2c5.58 0 10.12 4.54 10.12 10.12v119.76c0 5.58-4.54 10.12-10.12 10.12z"
  }))), _symbol205 || (_symbol205 = /*#__PURE__*/React.createElement("symbol", {
    id: "wide_23_17_26_selected",
    viewBox: "0 0 193 140",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, ".hyst0{fill:#338dc7}"), /*#__PURE__*/React.createElement("path", {
    className: "hyst0",
    d: "M183.32 140H10.12C4.54 140 0 135.46 0 129.88V18.12h10.12v111.76h173.2V10.12H0C0 4.54 4.54 0 10.12 0h173.2c5.58 0 10.12 4.54 10.12 10.12v119.76c0 5.58-4.54 10.12-10.12 10.12z"
  }))), _symbol206 || (_symbol206 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 140.061 160.236",
    id: "wide_au_14_16_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h119.984a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v140.172a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 131.878 119.965.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc"
  }))), _symbol207 || (_symbol207 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 140.061 160.236",
    id: "wide_au_14_16_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h119.984a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v140.172a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 131.878 119.965.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol208 || (_symbol208 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 189.866 160.297",
    id: "wide_ena_19_16_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h169.789a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v140.232a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 131.939 169.769.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#c6cacc"
  }))), _symbol209 || (_symbol209 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 189.866 160.297",
    id: "wide_ena_19_16_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h169.789a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v140.232a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.067a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936V18.109h10l.02 131.939 169.769.249V10.064H.068s-.757-2.873 2.786-6.83 7.213-3.17 7.213-3.17z",
    fill: "#338dc7"
  }))), _symbol210 || (_symbol210 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 220.077 130.065",
    id: "wide_ena_20_13_24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h200a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v110a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039h-200A10.815 10.815 0 012.75 127a8.591 8.591 0 01-2.683-6.936V18.109h10l.02 101.706 199.98.249v-110h-210s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#c6cacc"
  }))), _symbol211 || (_symbol211 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 220.077 130.065",
    id: "wide_ena_20_13_24_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.067.064h200a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211v110a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039h-200A10.815 10.815 0 012.75 127a8.591 8.591 0 01-2.683-6.936V18.109h10l.02 101.706 199.98.249v-110h-210s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))), _symbol212 || (_symbol212 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 160.17 139.916",
    id: "wide_selected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181.064H150.17a10.659 10.659 0 017.095 2.789 11.821 11.821 0 012.905 7.211l-.143 119.852a9.456 9.456 0 01-2.763 6.961 11.214 11.214 0 01-7.237 3.039H10.038a10.815 10.815 0 01-7.317-3.064 8.591 8.591 0 01-2.683-6.936L.181 18.109h10l-.123 111.558 139.97.249.142-119.852H.181s-.757-2.873 2.786-6.83 7.214-3.17 7.214-3.17z",
    fill: "#338dc7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBundle);
export default __webpack_public_path__ + "static/media/icons-bundle.4876ece02ffae8c1c3c1b3b21cf52c97.svg";
export { ForwardRef as ReactComponent };